import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { takeUntil, map, shareReplay, catchError } from 'rxjs/operators';
import { FavoriteMedicineData } from '../../../../@core/interfaces/masters/favoritemedicine';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrAppSrvcService } from '../../../../_services/toastr-app-srvc.service';
import { InvestigationData } from '../../../../@core/interfaces/masters/investigations';
import { PatientDiagnosisData } from '../../../../@core/interfaces/masters/patientdiagnosis';
import { INgxSelectOption, NgxSelectComponent } from 'ngx-select-ex';
import { environment } from '../../../../../environments/environment';
import { DateService } from '../service/date.service';
import { PatientPrescriptionData } from '../../../../@core/interfaces/masters/patientprescription';
import { GlossaryData } from '../../../../@core/interfaces/masters/glossary';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import * as severity from './../../../../data/severity.json';
import { NgSelectComponent } from '@ng-select/ng-select';
import { PeriodOptions } from '../../../../@core/interfaces/masters/patientAllergy';
import * as relationship from './../../../../data/famly-medical-relationship.json';
import { SocialHabitsData } from '../../../../@core/interfaces/masters/socialhabits';
import { NbDateService } from '@nebular/theme';
import { formatDate } from '@angular/common';
import { ServiceCategoryData } from '../../../../@core/interfaces/masters/servicecategory';
// convoAI start here
import { AudioSpeechService, FinalTranscriptPayload } from '../service/audio-speech.service';
import { TemperatureUnitService, TempRange } from '../service/temperature-unit.service';
// convoAI end here
import { Router } from '@angular/router';
import { LabresultmstData } from '../../../../@core/interfaces/masters/labresultmst';
import { LabResultData } from '../../../../@core/interfaces/lab/lab-result-detail';
import { RadiologyEhrData } from '../../../../@core/interfaces/ehr/radiology-ehr';
import { Leads12 } from '../../../../@core/interfaces/device-integration/device-item.model';


interface Prescription {
  medicine: string;
  dosage: string;
  frequency: string;
  duration: string;
  routine: string;
  whenToTake: string;
  id?: number;
}

interface Complaint {
  id: number;
  name: string;
  duration: string;
  severity: string;
}

@Component({
  selector: 'ngx-ehr',
  templateUrl: './ehr.component.html',
  styleUrls: ['./ehr.component.scss', '../../../../../assets/css/care-sphere-md3.css']
})
export class EhrComponent implements OnInit, OnDestroy {
  tempSymbol: string;
  tempRange: TempRange;
  sections: any[] = []; // Array of { title: string, fields: any[] }
  periodList: PeriodOptions[] = [
    { value: "days" },
    { value: "weeks" },
    { value: "months" },
    { value: "years" },

  ];
  socialHabitStatusList = [{ id: 1, name: "None" }, { id: 2, name: "Occasional" }, { id: 3, name: "Regular" }]
  severityList: string[] = (severity as any).default;
  categoryList: Array<any> = [];
  reactionsList: Array<any> = [];
  dflag: boolean = false;
  bloodSugarUnit: string = localStorage.getItem('bloodSugarUnit') || 'mg/dL';
  bloodGroup: any = {};
  quickComplaints = [];
  quickDiagnoses = [];
  quickInvestigations = [];
  openMedicalHistoryCard: boolean = false;
  openVitals: boolean = false;
  openCurrentMedication: boolean = false;
  openFamilyCard: boolean = false;
  openSocialHabits: boolean = false;
  openAllergyCard: boolean = false;
  // openBloodGroupCard: boolean = false;
  openComplaintCard: boolean = false;
  openDiagnosisCard: boolean = false;
  openInvestigationCard: boolean = false;
  openPrescriptionCard: boolean = false;
  openFollowupCard: boolean = false;
  activeSection: string = null;
  activeTopTab: string = 'ehr';

  // ===== Lab Report (EHR-embedded, adapted from patient-portal lab-report.component) =====
  labReportData: any[] = [];
  labReportFullData: any[] = [];
  labReportTerm: string;
  labReportIsOrderWise: boolean = true;
  labReportIsTestWise: boolean = false;
  labReportGroupedData: any[] = [];
  labReportShowHistoryHeaders: any;
  labReportP: number = 1;
  labReportChartShow: boolean = false;
  labReportSeriesList: any[] = [];
  labReportChartView: any[] = [700, 300];
  labReportColorScheme = { domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5'] };
  labReportGradient: boolean = false;

  // ===== Vitals History popup (Grid View + Graphical View), Vitals tab (video-consultation EHR) =====
  vitalsHistoryOpen: boolean = false;
  vitalsHistoryLoading: boolean = false;
  vitalsHistoryRows: any[] = [];
  vitalsHistoryTab: 'grid' | 'graph' = 'grid';
  vitalsHistoryMetric: string = 'bp';
  vitalsHistorySeries: any[] = [];
  vitalsHistoryChartView: any[] = [640, 280];
  vitalsHistoryColorScheme = { domain: ['#2151A0', '#E44D25', '#5AA454', '#a8385d'] };
  vitalsHistoryGradient: boolean = false;
  private vitalsHistoryLoadedForReg: string = null;
  readonly vitalsHistoryMetrics: Array<{ id: string, label: string }> = [
    { id: 'bp', label: 'Blood Pressure' },
    { id: 'pulse', label: 'Pulse' },
    { id: 'temp', label: 'Temperature' },
    { id: 'respRate', label: 'Respiration' },
    { id: 'spo2', label: 'SpO2' },
    { id: 'glucose', label: 'Blood Sugar' },
    { id: 'fetusHeartRate', label: 'Fetal Heart Rate' },
  ];

  get vitalsHistoryYAxisLabel(): string {
    return this.vitalsHistoryMetrics.find(m => m.id === this.vitalsHistoryMetric)?.label || '';
  }

  get vitalsHistoryGridRows(): any[] {
    return (this.vitalsHistoryRows || []).slice(-8).reverse().map(r => ({
      date: r?.date,
      spo2: (r?.spo2 !== null && r?.spo2 !== undefined && r?.spo2 !== '') ? `${r.spo2} %` : '-',
      temp: (r?.temp !== null && r?.temp !== undefined && r?.temp !== '') ? `${r.temp} ${this.tempSymbol}` : '-',
      pulse: (r?.pulse !== null && r?.pulse !== undefined && r?.pulse !== '') ? `${r.pulse} BPM` : '-',
      bp: (r?.bpSys !== null && r?.bpSys !== undefined && r?.bpSys !== '' && r?.bpDia !== null && r?.bpDia !== undefined && r?.bpDia !== '') ? `${r.bpSys}/${r.bpDia} mmHg` : '-',
      glucose: this.vitalsHistoryGlucoseCell(r),
      fetusHeartRate: (r?.fetusHeartRate !== null && r?.fetusHeartRate !== undefined && r?.fetusHeartRate !== '') ? `${r.fetusHeartRate} BPM` : '-',
    }));
  }

  // ===== Radiology (EHR-embedded, adapted from patient-portal radiology-report.component) =====
  radiologyFilesDet: any[] = [];
  radiologyFullData: any[] = [];
  radiologyTerm: string;
  radiologyP: number = 1;
  radiologyImgView: boolean = false;
  radiologyImgName: any;
  radiologyViewData: any;

  // ===== Triage Captures (EHR-embedded, video-consultation only) =====
  generalExamFilesDet: any[] = [];
  ecgFilesDet: any[] = [];
  fetalDopplerFilesDet: any[] = [];
  stethoscopeFilesDet: any[] = [];
  triageAttachmentImgView: boolean = false;
  triageAttachmentImgName: any;
  triageAttachmentVideoView: boolean = false;
  triageAttachmentVideoUrl: SafeUrl | null = null;
  triageAttachmentAudioView: boolean = false;
  triageAttachmentAudioUrl: SafeUrl | null = null;
  triageAttachmentEcgView: boolean = false;
  triageAttachmentEcgSamples: Leads12[] = [];
  private currentTriageBlobUrl: string | null = null;

  valuefield: string;
  @Input() docId: string;
  @Input() regId: string;
  @Input() visitId: string;
  HistoryTypeList: Array<any> = [{ id: 1, Name: 'Mental General' }, { id: 2, Name: 'Physical General' }, { id: 3, Name: 'Physical Makeup' }, { id: 4, Name: 'Gynaecological History' }, { id: 5, Name: 'Surgical History' }, { id: 9, Name: 'Treatment History' }, { id: 6, Name: 'Homeopathic Medicine' }, { id: 7, Name: 'Obsterics History' }, { id: 8, Name: 'Marital Life' }, { id: 10, Name: 'Medical History' }, { id: 11, Name: 'Dental History' }, { id: 12, Name: 'Implant History' }, { id: 13, Name: 'Illness History' }, { id: 14, Name: 'Doctor Assessment' }];
  HistoryMaleType: Array<any> = [{ id: 1, Name: 'Mental General' }, { id: 2, Name: 'Physical General' }, { id: 3, Name: 'Physical Makeup' }, { id: 5, Name: 'Surgical History' }, { id: 9, Name: 'Treatment History' }, { id: 6, Name: 'Homeopathic Medicine' }, { id: 8, Name: 'Marital Life' }, { id: 10, Name: 'Medical History' }, { id: 11, Name: 'Dental History' }, { id: 12, Name: 'Implant History' }, { id: 13, Name: 'Illness History' }, { id: 14, Name: 'Doctor Assessment' }];
  @Input() gender: string;
  @Input() isFromViewRecord: boolean=false;
  protected readonly unsubscribe$ = new Subject<void>();
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private userId = localStorage.getItem("userId");
  performDocList: Array<any> = [];
  favoritesList: Array<any> = [];
  chiefComplaintList: Array<any> = [];
  InvestigationList: Array<any> = [];
  addedCurrentMedications: Array<any> = [];
  MedicineList: Array<any> = [];
  addedAllergies: Array<any> = [];
  patientAddedComplaints: Array<any> =[];
  addedComplaints: Array<any> = [];
  addedDiagnosis: Array<any> = [];
  addedInves: Array<any> = [];
  addedPrescription: any = [];
  // patientClinicalMst: any = {};
  addedSocialHabits: Array<any> = [];
  addedFamilyHistories: Array<any> = [];
  addedMedicalHistories: Array<any> = [];
  phlen: number = 4000;
  phcharflag: boolean = false;
  addedfollowUp: Array<any> = [];
  diagEdit: boolean = false;
  compEditIndex: number;
  isSubmittedAllergy: boolean = false;
  socialEditIndex: number;
  allergyEditIndex: number;
  compEdit: boolean = false;
  allergyEdit: boolean = false;
  socialHabitEdit: boolean = false;
  diaEditIndex: number;
  duplicateDiag: boolean = false;
  socialHabitEditData: any = {};
  allergyEditData: any = {};
  compEditData: any = {};
  diagEditData: any = {};
  invesEditData: any = {};
  presEditData: any = {};
  medHistoryEditIndex: number;
  medHisEdit: boolean = false;
  medHistoryEditData: any = {};
  currMedEditIndex: number;
  currMedEdit: boolean = false;
  currMedEditData: any = {};
  familyHistoryEditIndex: number;
  familyHisEdit: boolean = false;
  familyHistoryEditData: any = {};
  duplicateAllergy: boolean = false;
  duplicateSocialHabit: boolean = false;
  duplicateExistsComplain: boolean = false;
  invesEdit: boolean = false;
  invesEditIndex: number;
  duplicateInves: boolean = false;
  patientmedicalHistoryForm: FormGroup;
  patientmedicationEditForm: FormGroup;
  FamilyHisForm: FormGroup;
  vitalForms: FormGroup;
  prescriptionForm: FormGroup;
  patientcomplaintEditForm: FormGroup;
  patientAllergyEditForm: FormGroup;
  patientSocialHabitsEditForm: FormGroup;
  diagnosisForm: FormGroup;
  investigationform: FormGroup;
  followUpForm: FormGroup;
  today: Date = new Date();
  isSubmittedSocial: boolean = false;
  isSubmittedCom: boolean = false;
  isSubmittedDiag: boolean = false;
  isSubmittedVitals: boolean = false;
  isSubmittedFam: boolean = false;
  duplicateFamHis: boolean = false;
  duplicateMedicalHistory: boolean = false;
  isSubmittedBloodGroup: boolean = false;
  get fvalBlood(): { [key: string]: AbstractControl } { return this.bloodgroupForm.controls; }
  get fvalMedHis(): { [key: string]: AbstractControl } { return this.patientmedicalHistoryForm.controls; }
  get fvalCurMed(): { [key: string]: AbstractControl } { return this.patientmedicationEditForm.controls; }
  get fvalFamHis(): { [key: string]: AbstractControl } { return this.FamilyHisForm.controls; }
  get fvalAllergy(): { [key: string]: AbstractControl } { return this.patientAllergyEditForm.controls; }
  get fvalCom(): { [key: string]: AbstractControl } { return this.patientcomplaintEditForm.controls; }
  get fval(): { [key: string]: AbstractControl } { return this.prescriptionForm.controls; }
  get fvalfollow(): { [key: string]: AbstractControl } { return this.followUpForm.controls; }
  get fvalDia(): { [key: string]: AbstractControl } { return this.diagnosisForm.controls; }
  get fvalInves(): { [key: string]: AbstractControl } { return this.investigationform.controls; }
  get fvalVitals(): { [key: string]: AbstractControl } { return this.vitalForms.controls; };
  get fvalSocial(): { [key: string]: AbstractControl } { return this.patientSocialHabitsEditForm.controls; }
  vitalsData: any = {};
  tempVitalsData: any = {};
  durationPeriod: Array<any> = ["1d", "2d", "5d", "1w", "1m"];
  duplicateCurrMed: boolean = false;
  isSubmittedCurrMed: boolean = false;
  isSubmittedMedHis: boolean = false;
  isSubmittedInves: boolean = false;
  presEdit: boolean = false;
  presEditIndex: number;
  duplicatePres: boolean = false;
  isSubmittedPres: boolean = false;
  skip: number = 0;
  take: number = 50;
  name: string = "";
  serviceMstId: string = null;
  dossageData: Array<any> = ["1", "1.5", "2.5", "3.0", "4.0", "5.0", "7.0", "8.0", "9.0", "10.0"];
  dosageLvl: any = '';
  onceData: any = []
  twiceData: any = [];
  thriceData: any = [];
  fouthData: any = [];
  frequency: string;
  showadvancedtiming: boolean = false;
  physicianMedicineProperties: Array<any> = [];
  physicianMedicinePropertiesCount: number = 0;
  checkdata: boolean = true;
  dossageLevelData: Array<any> = ["nos", "ml", "gms"];
  routineData: Array<any> = [];
  whentotakenData: Array<any> = [];
  frequencyData: Array<any> = [];
  sclDosage: any = [false, false, false, false];
  onceAMonthErr: boolean = false;
  onceAWeekErr: boolean = false;
  alternateDayErr: boolean = false;
  mrng: number = 0;
  noon: number = 0;
  eveng: number = 0;
  night: number = 0;
  incorrectformatduration: boolean = false;
  isfavorite: boolean = false;
  nameflag: boolean = false;
  mname: string = "";
  newFavoriteForm: FormGroup;
  get fval1(): { [key: string]: AbstractControl } { return this.newFavoriteForm.controls; }
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
  isPastRecord: boolean = false;
  visitHistoryData: Array<any> = [];
  p: number = 1;
  p1: number = 1;
  patComPage: number = 1;
  medicalRecords: Array<any> = [];
  pastPrescriptionHistories: Array<any> = [];
  isImgView: boolean = false;
  pdfUrl: SafeResourceUrl | null = null;
  srcname: any;
  @Input() curDetPat: any;
  @Input() fromPage: string;
  showVitalsForm: boolean = false;
  showComplaintForm: boolean = false;
  showAllergyForm: boolean = false;
  showDiagnosisForm: boolean = false;
  showInvestigationForm: boolean = false;
  showPrescriptionForm: boolean = false;
  showFollowupForm: boolean = false;
  showFamilyForm: boolean = false;
  showSocialHabitsForm: boolean = false;
  showMedicalHistoryForm: boolean = false;
  showCurrentMedicationForm: boolean = false;
  // convoAI start here
  // Speech Recording State
  isSpeechRecording: boolean = false;
  accumulatedSpeechText: string = '';
  interimSpeechText: string = '';
  // MULTILANG-START
  supportedLanguages: any[] = [];
  selectedLanguage: string = 'en-IN';
  accumulatedTranslation: string = '';
  interimTranslation: string = '';
  activeTranscriptView: 'original' | 'translation' = 'original';
  // MULTILANG-END
  wordCount: number = 0;
  charCount: number = 0;
  private speechSilenceTimer: any;
  private lastSpeechSeq: number = -1;
  private manualUpdateTimer: any;
  private lastSyncedManualText: string = '';
  // MULTILANG-START
  private lastSyncedManualTranslation: string = '';
  // MULTILANG-END
  private readonly manualSyncDelay = 1500;
  private pendingSpeechEditorSyncOptions: any;
  private speechEditorSyncHandle: any;
  private speechEditorFocused: boolean = false;
  private medicalDataSubject = new Subject<any>();
  public medicalData$: Observable<any> = this.medicalDataSubject.asObservable();

  isAIComplete = false;
  aiCompleteMessage = '';
  private aiToastTimer: any;
  finalAIData: any = null;
  sessionStatus: 'disconnected' | 'initializing' | 'connected' = 'disconnected';
  sessionStatusText: string = 'Disconnected';

  // Conversation AI loader (Listening -> Translating -> Analyzing with AI -> Populating EHR)
  isConversationAILoading: boolean = false;
  // True only while AI Suggestions data (sections) is actively being populated - drives the
  // in-card "Populating EHR" indicator independently of whether the AI Suggestions block is rendered.
  isAISuggestionsPopulating: boolean = false;
  conversationAIStageIndex: number = 0;
  readonly conversationAIStages: { text: string; icon: string }[] = [
    { text: 'Listening', icon: 'fa-microphone' },
    { text: 'Translating', icon: 'fa-language' },
    { text: 'Analyzing with AI', icon: 'fa-brain' },
    { text: 'Populating EHR', icon: 'fa-notes-medical' },
  ];
  private conversationAIStageTimer: any;
  // convoAI end here
  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();
  // Fires once HomeopathyCasesheetSave succeeds (second-opinion doctor flow logs a triage row on it).
  @Output() casesheetSaved: EventEmitter<any> = new EventEmitter<any>();
  editVitals: boolean = false;
  // editBlood: boolean = false;
  // bloodGroupId:string;
  isFollowUpSubmitted: boolean = false;
  FollowEdit: boolean = false;
  FollowEditIndex: number;
  allergyAllList: Array<any> = [];
  medicalHistoryMasterList: Array<any> = [];
  MedicalHistoryAllList: Array<any> = [];
  AllMedicalHistoryBackup: Array<any> = [];
  relationshipList: Array<any> = (relationship as any).default;
  socialHabitsAllList: Array<any> = [];
  DateExceeds: boolean = false;
  max = new Date();
  MedicineListForCurr: Array<any> = [];
  extensionList: Array<any> = [{ id: 1, name: 'Paternal' }, { id: 2, name: 'Maternal' }]
  bloodData: Array<any> = [];
  bloodgroupForm: FormGroup;
  @ViewChild('complaintSelect') complaintSelect!: NgxSelectComponent;
  @ViewChild('diagSelect') diagSelect!: NgxSelectComponent;
  @ViewChild('invesSelect') invesSelect!: NgSelectComponent;
  @ViewChild('medicineSelect') medicineSelect!: NgxSelectComponent;
  @ViewChild('docSelect') docSelect!: NgxSelectComponent;
  @ViewChild('allergySelect') allergySelect!: NgxSelectComponent;
  @ViewChild('famHisDrop') famHisDrop!: NgxSelectComponent;
  @ViewChild('socialHabitsDrop') socialHabitsDrop!: NgxSelectComponent;
  @ViewChild('currMedDrop') currMedDrop!: NgxSelectComponent;
  @ViewChild('bloodGroupDrop') bloodGroupDrop!: NgxSelectComponent;
  @ViewChild('medHisDrop') medHisDrop!: NgxSelectComponent;
  @ViewChild('speechTextEditor') speechTextEditorRef: ElementRef;
  
  constructor(public audioSpeechService: AudioSpeechService, private cdr: ChangeDetectorRef, private listapi: ServiceCategoryData, protected dateService: NbDateService<Date>, protected socialSrvc: SocialHabitsData, private sanitizer: DomSanitizer, protected glossarySrvc: GlossaryData, protected patientPrescriptionSrvc: PatientPrescriptionData, public datService: DateService, protected patientDiagnosisData: PatientDiagnosisData, protected patientinvestigationSrvc: InvestigationData, private toaster: ToastrAppSrvcService, protected fb: FormBuilder, protected favoriteMedicineSrvc: FavoriteMedicineData, private rolesService: RolesData, private router: Router, protected labResult: LabresultmstData, protected labResultSrvc: LabResultData, private radiologySrvc: RadiologyEhrData, public tempUnitService: TemperatureUnitService) {
    this.tempSymbol = this.tempUnitService.getSymbol();
    this.tempRange  = this.tempUnitService.getRange();
    // this.bloodgroupForm = this.fb.group({
    //   bloodGroupId: this.fb.control('', [Validators.required])
    // });

    this.patientmedicalHistoryForm = this.fb.group({
      medicalHistoryId: this.fb.control('', [Validators.required]),
      duration: this.fb.control('', [Validators.pattern('^[0-9]+$')]),
      period: this.fb.control('', []),
      notes: this.fb.control('', [Validators.maxLength(250)]),
      historyType: this.fb.control(10, [Validators.required]),
      startDate: this.fb.control('', []),
      endDate: this.fb.control('', []),
      isActive: this.fb.control('', []),

      attributeDetail: this.fb.control([]),
      year: this.fb.control(null, [Validators.pattern('^[0-9-]+$'), Validators.maxLength(3), Validators.max(150)]),
      month: this.fb.control(null, [Validators.pattern('^[0-9-]+$'), Validators.maxLength(2), Validators.min(0), Validators.max(12)]),
      day: this.fb.control(null, [Validators.pattern('^[0-9-]+$'), Validators.maxLength(2), Validators.min(0), Validators.max(31)]),
    });

    this.patientmedicationEditForm = this.fb.group({
      medicineId: this.fb.control(null, [Validators.required]),
      isActive: this.fb.control(null),
      startdate: this.fb.control(null),
      enddate: this.fb.control(null),
      reason: this.fb.control(null, [Validators.pattern('[a-zA-Z0-9 ]*$')]),
      timingLevel: this.fb.control(''),
      night: this.fb.control('', []),
      noon: this.fb.control('', []),
      evening: this.fb.control('', []),
      mrng: this.fb.control('', []),
    });
    this.patientSocialHabitsEditForm = this.fb.group({
      socialHabitsId: this.fb.control('', [Validators.required]),
      duration: this.fb.control('', [Validators.pattern('^\\d{1,4}$')]),
      period: this.fb.control('',),
      notes: this.fb.control('', [Validators.maxLength(250)]),
      socialHabitStatus: this.fb.control(null),
      quantity: this.fb.control(null, [Validators.pattern('^\\d{1,4}$')]),
      quantityInPeriod: this.fb.control(null)
    });
    this.FamilyHisForm = this.fb.group({
      medicalHistoryId: this.fb.control('', [Validators.required]),
      relationship: this.fb.control('', [Validators.required]),
      notes: this.fb.control('', [Validators.maxLength(250)]),
      relationshipExtension: this.fb.control('')
    });
    this.patientAllergyEditForm = this.fb.group({
      allergyId: this.fb.control('', [Validators.required]),
      duration: this.fb.control('', [Validators.pattern('^[0-9]+$')]),
      period: this.fb.control('',),
      notes: this.fb.control('', [Validators.maxLength(250)]),
      isActive: this.fb.control('IsActive',),
      verificationStatus: this.fb.control('', []),
      severity: this.fb.control('', []),
    });
    this.vitalForms = this.fb.group({
      takenDatetime: this.fb.control(null),
      bP_Sys: this.fb.control(null, [Validators.min(0), Validators.max(500), Validators.pattern('^[0-9.]+$')]),
      bP_Dia: this.fb.control(null, [Validators.min(0), Validators.max(500), Validators.pattern('^[0-9.]+$')]),
      pulse: this.fb.control(null, [Validators.min(30), Validators.max(200), Validators.pattern('^[0-9.]+$')]),
      pre_Sugar: this.fb.control(null, [Validators.min(70), Validators.max(140), Validators.pattern('^[0-9.]+$')]),
      post_Sugar: this.fb.control(null, [Validators.min(80), Validators.max(180), Validators.pattern('^[0-9.]+$')]),
      random_Sugar: this.fb.control(null, [Validators.min(70), Validators.max(200), Validators.pattern('^[0-9.]+$')]),
      temp: this.fb.control(null, this.tempUnitService.getValidators()),
      resp_Rate: this.fb.control(null, [Validators.min(0), Validators.max(200), Validators.pattern('^[0-9.]+$')]),
      spo2: this.fb.control(null, [Validators.min(50), Validators.max(100), Validators.pattern('^[0-9.]+$')]),
    })

    this.investigationform = this.fb.group({
      serviceId: this.fb.control('', [Validators.required]),
      notes: this.fb.control('', [Validators.maxLength(4000)]),
      serviceName: this.fb.control(''),
    })

    this.diagnosisForm = this.fb.group({
      diagnosisId: this.fb.control('', [Validators.required]),
      diagnosisName: this.fb.control('', [Validators.required]),
      updatedDiagnosisId: this.fb.control(''),
      treatmentGiven: this.fb.control('', [Validators.maxLength(4000)])
    });

    this.patientcomplaintEditForm = this.fb.group({
      chiefComplaintId: this.fb.control('', [Validators.required]),
      presentHistory: this.fb.control('', [Validators.maxLength(1500)]),
      extraOption: this.fb.control(null),
      duration: this.fb.control(null),
      period: this.fb.control(null),
      selecteddays: this.fb.control(null),
    });

    this.prescriptionForm = this.fb.group({
      night: this.fb.control('', []),
      aft: this.fb.control('', []),
      eve: this.fb.control('', []),
      mor: this.fb.control('', []),
      medicineId: this.fb.control(null, [Validators.required]),
      genericName: this.fb.control('', []),
      categoryName: this.fb.control('', []),
      dosageunit: this.fb.control('', [Validators.required]),
      dosage: this.fb.control('', [Validators.required]),
      frequency: this.fb.control(''),
      takenAt: this.fb.control(''),
      duration: this.fb.control(null),
      qty: this.fb.control(null),
      availablequantity: this.fb.control(null, []),
      categoryID: this.fb.control('', []),
      genericID: this.fb.control('', [Validators.required]),
      instructions: this.fb.control('', []),
      medicineName: this.fb.control('', []),
      presNameForQC: this.fb.control('', []),
      days: this.fb.control(null, []),
      durationcount: this.fb.control(null, []),
      durationunit: this.fb.control('', []),
      favorite: this.fb.control('', []),
      createdDate: this.fb.control(null),
    });

    this.followUpForm = this.fb.group({
      date: this.fb.control('', [Validators.required]),
      Observation: this.fb.control('',),
      treatment: this.fb.control('',),
      doctor: this.fb.control('', [Validators.required]),
    });

    this.newFavoriteForm = this.fb.group({
      name: this.fb.control(null, [Validators.required, Validators.pattern(".*\\S.*[a-zA-z0-9 ]")])
    });
  }

  // convoAI start here
  // Method to process and group incoming data
  processData(data: any) {
    // console.log('[AI] Raw socket data received:', JSON.stringify(data).substring(0, 400));

    // Support both { group_result: [] } and { details: { group_result: [] } }
    const result = data?.group_result || data?.details?.group_result || [];

    if (!result.length) {
      // console.warn('[AI] group_result is empty. full_data preview:', JSON.stringify(data).substring(0, 400));
      return;
    }

    // console.log(`[AI] Processing ${result.length} fields from group_result:`, result.map(i => i.label).join(', '));

    const sectionsMap = new Map<string, any[]>();

    // 1. Initialize map with existing sections to preserve edits and state
    this.sections.forEach(section => {
      sectionsMap.set(section.title, section.fields.map((f: any) => ({ ...f })));
    });

    const savedSections = this.audioSpeechService.getSavedAISuggestions() || [];

    const canonicalStringify = (val: any): string => {
      if (val === null || val === undefined) return '';
      if (Array.isArray(val)) {
        return '[' + val.map(canonicalStringify).join(',') + ']';
      }
      if (typeof val === 'object') {
        const sortedKeys = Object.keys(val)
          .filter(k => !k.startsWith('$') && !k.startsWith('__'))
          .sort();
        const objParts = sortedKeys.map(k => `"${k}":${canonicalStringify(val[k])}`);
        return '{' + objParts.join(',') + '}';
      }
      return String(val).trim().toLowerCase();
    };

    const isValEqual = (v1: any, v2: any) => {
      if (v1 === v2) return true;
      return canonicalStringify(v1) === canonicalStringify(v2);
    };

    const getMedicineIdentity = (med: any): string => {
      const name = (med.medicineName || med.name || '').trim().toLowerCase();
      const dosage = (med.dosage || med.unit || '').trim().toLowerCase();
      const freq = (med.frequencyRoutine || med.frequency || '').trim().toLowerCase();
      return `${name}|${dosage}|${freq}`;
    };

    const mergeMedicineLists = (existingList: any[], incomingList: any[]): any[] => {
      const merged = [...existingList];

      incomingList.forEach(incomingMed => {
        const incomingId = getMedicineIdentity(incomingMed);

        // Find if there is an existing medicine with the same composite identity
        const matchIdx = merged.findIndex(existingMed => getMedicineIdentity(existingMed) === incomingId);

        if (matchIdx > -1) {
          // In-place update: merge properties from incomingMed to existingMed
          const existingMed = merged[matchIdx];
          const updatedMed = { ...existingMed };

          Object.keys(incomingMed).forEach(key => {
            const incomingVal = incomingMed[key];
            // Update if key is not empty
            if (incomingVal !== undefined && incomingVal !== null && incomingVal !== '' && incomingVal !== '-') {
              updatedMed[key] = incomingVal;
            }
          });
          merged[matchIdx] = updatedMed;
        } else {
          // Append clinically distinct medicine
          merged.push({ ...incomingMed });
        }
      });

      return merged;
    };

    const isSimilar = (s1: string, s2: string): boolean => {
      const v1 = (s1 || '').trim().toLowerCase();
      const v2 = (s2 || '').trim().toLowerCase();
      if (!v1 || !v2) return false;
      if (v1 === v2) return true;

      // If one contains the other, they are highly related/similar
      if (v1.includes(v2) || v2.includes(v1)) return true;

      // Check word overlap
      const words1 = new Set(v1.split(/\s+/).filter(w => w.length > 2));
      const words2 = new Set(v2.split(/\s+/).filter(w => w.length > 2));
      if (words1.size === 0 || words2.size === 0) return false;

      let intersection = 0;
      words1.forEach(w => {
        if (words2.has(w)) intersection++;
      });

      const maxWords = Math.max(words1.size, words2.size);
      const similarity = intersection / maxWords;

      return similarity > 0.4; // 40% or more identical words
    };

    const mergeStrings = (existing: string, incoming: string): string => {
      const ext = (existing || '').trim();
      const inc = (incoming || '').trim();
      if (!ext) return inc;
      if (!inc) return ext;

      const extLower = ext.toLowerCase();
      const incLower = inc.toLowerCase();

      // If one contains the other, choose the longer one
      if (incLower.includes(extLower)) {
        return inc;
      }
      if (extLower.includes(incLower)) {
        return ext;
      }

      // Find overlap at the end of existing and start of incoming
      let overlapLen = 0;
      const minLen = Math.min(ext.length, inc.length);
      for (let i = 1; i <= minLen; i++) {
        if (extLower.endsWith(incLower.substring(0, i))) {
          overlapLen = i;
        }
      }

      if (overlapLen > 0) {
        return ext + inc.substring(overlapLen);
      }

      // If no overlap, join with a space
      return ext + " " + inc;
    };

    const uniqueLabels = ["presenthistory", "notes", "duration", "period", "performingdoctor", "performingstaff", "wheelchairusage", "risk"];
    const mergeLabels = ["presenthistory", "notes", "complaint", "symptom", "diagnosis", "investigation"];

    const isLogicalEntityEqual = (f: any, item: any): boolean => {
      if ((f.label || "").toLowerCase() !== (item.label || "").toLowerCase()) return false;

      const labelLower = (f.label || "").toLowerCase();

      // Unique/scalar fields are matched solely by label to avoid duplicate boxes in the UI
      if (uniqueLabels.includes(labelLower)) {
        return true;
      }

      // For medicines, they are grouped under the same 'medicines' list field
      if (f.isMedicineList && Array.isArray(f.value) && Array.isArray(item.value)) {
        return true;
      }

      // For other fields (complaint, diagnosis, etc.), check if values are highly similar
      if (typeof f.value === 'string' && typeof item.value === 'string') {
        return isSimilar(f.value, item.value);
      }

      // Default: compare exact values
      return isValEqual(f.value, item.value);
    };

    // 2. Process incoming result from AI
    result.forEach((item: any) => {
      const title = item.title || 'Other';
      if (!sectionsMap.has(title)) {
        sectionsMap.set(title, []);
      }

      const existingFields = sectionsMap.get(title)!;
      const existingField = existingFields.find((f: any) => isLogicalEntityEqual(f, item));

      const isMedicineList = Array.isArray(item.value);
      const isObjectValue = this.isObject(item.value);

      if (!existingField) {
        existingFields.push({
          title,
          label: item.label,
          value: item.value,
          isMedicineList: isMedicineList,
          isObjectValue: isObjectValue,
          medicineColumns: isMedicineList ? this.getMedicineColumns(item.value) : [],
          is_accepted: item.is_accepted || false,
          is_rejected: item.is_rejected || false,
          is_edited: false
        });
      } else {
        const isSaved = savedSections.find((s: any) => s.title === title)?.fields.find((f: any) => isLogicalEntityEqual(f, item));
        
        // Merge values for long text fields to keep a single input box and append new content
        const labelLower = (existingField.label || "").toLowerCase();
        if (mergeLabels.includes(labelLower) && typeof existingField.value === 'string' && typeof item.value === 'string') {
          existingField.value = mergeStrings(existingField.value, item.value);
        } else if (!existingField.is_edited && !existingField.is_accepted && !existingField.is_rejected && !isSaved) {
          if (isMedicineList) {
            existingField.value = mergeMedicineLists(existingField.value || [], item.value || []);
          } else {
            existingField.value = item.value;
          }
          existingField.isMedicineList = isMedicineList;
          existingField.isObjectValue = isObjectValue;
          existingField.medicineColumns = isMedicineList ? this.getMedicineColumns(existingField.value) : [];
        }
      }
    });

    // 3. Ensure saved fields are present even if AI dropped them
    savedSections.forEach((savedSection: any) => {
      if (!sectionsMap.has(savedSection.title)) {
        sectionsMap.set(savedSection.title, []);
      }
      const existingFields = sectionsMap.get(savedSection.title)!;
      savedSection.fields.forEach((savedField: any) => {
        const existingField = existingFields.find((f: any) => f.label === savedField.label && isValEqual(f.value, savedField.value));
        if (!existingField) {
          existingFields.push({ ...savedField });
        }
      });
    });

    if (sectionsMap.size === 0) return;

    this.sections = Array.from(sectionsMap.entries()).map(([title, fields]) => ({
      title,
      displayTitle: this.formatTitle(title),
      fields
    }));

    // console.log('[AI] Sections updated:', this.sections.map((s: any) => `${s.displayTitle}(${s.fields.length})`).join(', '));
  }

  /** Returns the union of keys present across medicine objects, filtering out entirely empty columns */

  isT(v: any): boolean {
    return v === true || v === 'true' || v === '1' || v === 1;
  }

  isObject(val: any): boolean {
    return typeof val === 'object' && val !== null && !Array.isArray(val);
  }

  getMedicineColumns(medicines: any[]): string[] {
    const priorityOrder = [
      'medicineName', 'medicineCategory', 'dosage', 'unit', 'frequencyRoutine', 'mor', 'non', 'aft', 'eve', 'night', 'whenToTaken',
      'route', 'duration', 'dispenseQty', 'instructions', 'specialNotes', 'category',
      'genericName', 'routeMethod'
    ];

    const activeKeys = new Set<string>();

    // Only include a column if at least one medicine has a real value (not '-' or empty)
    priorityOrder.forEach(key => {
      const hasData = medicines.some(med => {
        const val = med[key];
        return val !== undefined && val !== null && val !== '' && val !== '-';
      });
      if (hasData) {
        activeKeys.add(key);
      }
    });

    // Catch any extra keys not in priorityOrder that might have data
    medicines.forEach(med => {
      Object.keys(med).forEach(k => {
        if (!activeKeys.has(k)) {
          const val = med[k];
          if (val !== undefined && val !== null && val !== '' && val !== '-') {
            activeKeys.add(k);
          }
        }
      });
    });

    return [...activeKeys];
  }

  formatTitle(title: string): string {
    if (!title) return '';
    // Handle camelCase and underscores
    return title
      .replace(/([A-Z])/g, ' $1') // Insert space before capital letters
      .split(/[_\s]+/) // Split by underscore or space
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
      .trim();
  }

  approveField(field: any) {
    field.is_accepted = true;
    field.is_rejected = false;
  }

  rejectField(field: any) {
    field.is_rejected = true;
    field.is_accepted = false;
  }

  removeMedicineRow(field: any, idx: number) {
    if (field && Array.isArray(field.value)) {
      field.value.splice(idx, 1);
      field.is_edited = true;
    }
  }

  approveAll() {
    this.sections.forEach(section => {
      section.fields.forEach((field: any) => {
        field.is_accepted = true;
        field.is_rejected = false;
      });
    });
  }

  rejectAll() {
    this.sections.forEach(section => {
      section.fields.forEach((field: any) => {
        field.is_rejected = true;
        field.is_accepted = false;
      });
    });
  }




  saveSuggestions(event: any) {
    // console.log('[AI] Saving approved AI suggestions from review screen...');

    // Step 1: Save to audio speech service
    this.audioSpeechService.saveAISuggestions(this.sections);

    // Step 2: Map AI suggestions to form arrays and get the mapped data
    const mappedData = this.mapAISuggestionsToFormsAndReturnData();

    // console.log('[AI] Mapped AI data:', {
    //   newPrescriptions: mappedData.newPrescriptions?.length || 0,
    //   newComplaints: mappedData.newComplaints?.length || 0,
    //   newDiagnosis: mappedData.newDiagnosis?.length || 0,
    //   newInvestigations: mappedData.newInvestigations?.length || 0,
    //   newFollowUps: mappedData.newFollowUps?.length || 0
    // });

    // Step 3: Build the postAPIConverstion payload using ALL data (existing + new AI)
    const payload = this.buildPostAPIConverstionPayload();

    // console.log('[AI] Full postAPIConverstion payload:', JSON.stringify(payload, null, 2));

    const sessionId = this.audioSpeechService.sessionId;
    const params = new URLSearchParams({
      session_id: sessionId || '',
      tenantId: this.tenandId || '',
      branchId: this.branchId || '',
      regId: this.regId || '',
      visitId: String(this.visitId || ''),
      docId: this.docId || '',
      createdBy: this.userId || ''
    });
    const pyUrl = `${environment.convoAIUrl}/save_converted_suggestions?${params.toString()}`;

    // Use the captured finalAIData instead of making another API call to get_final_ai
    const fullTranscript = this.finalAIData?.full_transcript || "";

    fetch(pyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...payload,
        full_transcript: fullTranscript,
        ai_complete: this.isAIComplete || false
      })
    })
      .then(res => res.json())
      .then(data => {
        // console.log('[AI] Stored in-memory via Python backend');
        this.toaster.ForSuccess('AI Suggestions converted and stored successfully');
      })
      .catch(err => {
        // console.error('[AI] Failed to reach Python backend:', err);
        this.toaster.ForDanger('AI JSON Payload logged to console. Check format manually.');
      });
  }


  subscribeToAIComplete() {
    this.audioSpeechService.aiComplete$.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      // console.log('[AI Complete] Signal received:', data);

      const isComplete = data.status === 'eos_sent' || data.status === 'completed' || data.status === 'complete' || data.status === 'partial';
      if (!isComplete) {
        return;
      }

      this.isAIComplete = true;
      this.aiCompleteMessage = 'AI processing complete — All suggestions received. Review and save when ready.';
      this.stopConversationAILoader();
      // All AI Suggestion sections have finished loading - safe to hide the "Populating EHR" indicator.
      this.isAISuggestionsPopulating = false;

      // ── Store the final data for database saving ──
      if (data.group_result) {
        // console.log('[AI] Final suggestions captured from socket:', data.group_result.length, 'items');
        this.finalAIData = {
          group_result: data.group_result,
          full_transcript: data.full_transcript || ""
        };
      }

      // Show the green production alert for final completion
      this.toaster.ForSuccess('AI Processing Complete - Ready for Review');

      // Auto-dismiss in-component toast after 15 seconds
      if (this.aiToastTimer) clearTimeout(this.aiToastTimer);
      this.aiToastTimer = setTimeout(() => {
        this.aiCompleteMessage = '';
        this.cdr.detectChanges();
      }, 15000);

      this.cdr.detectChanges();
    });
  }

  dismissAIToast() {
    this.aiCompleteMessage = '';
    if (this.aiToastTimer) {
      clearTimeout(this.aiToastTimer);
      this.aiToastTimer = null;
    }
  }

  // convoAI start here
  /** Mic is live: show the loader pinned on the "Listening" stage. */
  private startConversationAIListeningStage(): void {
    this.stopConversationAIStageCycle();
    this.isConversationAILoading = true;
    this.conversationAIStageIndex = 0;
  }

  /** Transcript handed off to the backend: cycle Translating -> Analyzing with AI, then hold. */
  private startConversationAIProcessingCycle(): void {
    this.isConversationAILoading = true;
    this.conversationAIStageIndex = 1;
    this.stopConversationAIStageCycle();
    this.conversationAIStageTimer = setInterval(() => {
      if (this.conversationAIStageIndex < this.conversationAIStages.length - 1) {
        this.conversationAIStageIndex++;
      } else {
        this.stopConversationAIStageCycle();
      }
      this.cdr.detectChanges();
    }, 2500);
  }

  private stopConversationAIStageCycle(): void {
    if (this.conversationAIStageTimer) {
      clearInterval(this.conversationAIStageTimer);
      this.conversationAIStageTimer = null;
    }
  }

  private stopConversationAILoader(): void {
    this.isConversationAILoading = false;
    this.stopConversationAIStageCycle();
  }
  // convoAI end here


  /**
   * Maps approved AI suggestions into the actual EHR form arrays
   * and returns the mapped data for reference
   */
  /**
   * Maps approved AI suggestions into the actual EHR form arrays
   * and returns the mapped data for reference.
   * This version groups fragmented fields (name, duration, notes) into cohesive objects.
   */
  private mapAISuggestionsToFormsAndReturnData(): any {
    const newPrescriptions: any[] = [];
    const newComplaints: any[] = [];
    const newDiagnosis: any[] = [];
    const newInvestigations: any[] = [];
    const newFollowUps: any[] = [];
    const newVitals: any[] = [];

    let consolidatedTreatment = "";
    let consolidatedObservation = "";
    let consolidatedReason = "";
    let consolidatedFollowUpDate = "";
    let consolidatedDoctorName = "";
    let consolidatedAcceptedFields = [];

    // Find performing doctor globally across all sections first, as a fallback/default
    let globalPerformingDoctor: string | null = null;
    if (this.sections) {
      for (const sec of this.sections) {
        if (sec.fields) {
          const docField = sec.fields.find((f: any) => 
            (f.label || "").toLowerCase() === "performingdoctor" && 
            (f.is_accepted || f.is_edited) && 
            !f.is_rejected
          );
          if (docField && docField.value) {
            globalPerformingDoctor = docField.value;
            break;
          }
        }
      }
    }

    this.sections.forEach(section => {
      const titleLower = (section.title || "").toLowerCase();
      let allFields = section.fields.filter((f: any) => (f.is_accepted || f.is_edited) && !f.is_rejected);

      // Extract performingDoctor name directly from AI suggestion — pass raw name as-is
      const performingDoctorField = allFields.find((f: any) => (f.label || "").toLowerCase() === "performingdoctor");
      const resolvedDoctorId: string | null = performingDoctorField?.value || globalPerformingDoctor || null;

      const ignoreGlobal = ["performingdoctor", "performingstaff", "wheelchairusage", "risk"];
      let acceptedFields = allFields.filter((f: any) => !ignoreGlobal.includes((f.label || "").toLowerCase()));
      if (acceptedFields.length === 0) return;

      // 1. MEDICINES / PRESCRIPTIONS
      if (titleLower.includes("prescription") || titleLower.includes("medicine")) {
        acceptedFields.forEach((field: any) => {
          if (field.isMedicineList && Array.isArray(field.value)) {
            field.value.forEach((med: any) => {
              const medName = med.medicineName || med.name || "";
              const match = this.MedicineList?.find(m =>
                m.name && medName && m.name.toLowerCase().includes(medName.toLowerCase())
              );

              const isT = (v: any) => v === true || v === "true" || v === "1" || v === 1;
              let mor = isT(med.tod?.mor) || isT(med.mor) ? "1" : "0";
              let aft = isT(med.tod?.noon) || isT(med.noon) ? "1" : "0";
              let eve = isT(med.tod?.eve) || isT(med.eve) ? "1" : "0";
              let night = isT(med.tod?.night) || isT(med.night) ? "1" : "0";

              let freq = med.frequencyRoutine || med.frequency || "";
              const hasTod = mor === "1" || aft === "1" || eve === "1" || night === "1";

              if (hasTod) {
                freq = `${mor} - ${(aft === "1" || eve === "1") ? "1" : "0"} - ${night}`;
              } else if (freq) {
                const lowerFreq = freq.toLowerCase();
                if (lowerFreq.includes("three times") || lowerFreq.includes("tds") || lowerFreq.includes("tid")) {
                  mor = "1"; aft = "1"; night = "1"; freq = "1 - 1 - 1";
                }
                else if (lowerFreq.includes("twice") || lowerFreq.includes("bid") || lowerFreq.includes("bd")) {
                  mor = "1"; night = "1"; freq = "1 - 0 - 1";
                }
                else if (lowerFreq.includes("once") || lowerFreq.includes("od")) {
                  mor = "1"; freq = "1 - 0 - 0";
                }
              }

              const presObj = {
                medicineId: match?.id || 0,
                presNameForQC: medName || (match ? match.name : "Unknown Medicine"),
                medicine: match || { id: 0, name: medName, genericName: { name: "" } },
                genericID: med.genericId || match?.genericId || null,
                genericName: med.genericName || "",
                categoryName: med.category || match?.medicineCategory?.name || "",
                dosage: med.dosage || "1",
                dosageunit: med.unit || "nos",
                frequency: freq,
                takenAt: med.whenToTaken || "After Food",
                days: parseInt(med.duration) || 0,
                durationcount: parseInt(med.duration) || 0,
                durationunit: med.durationUnit || "Days",
                qty: med.dispenseQty || "0",
                instructions: med.specialNotes || med.instructions || "",
                advice: med.advice || "",
                mor: mor === "1" ? "1" : "0",
                non: aft === "1" ? "1" : "0",
                aft: aft === "1" ? "1" : "0",
                eve: eve === "1" ? "1" : "0",
                night: night === "1" ? "1" : "0",
                performingDoctor: resolvedDoctorId,
                visitId: this.visitId
              };
              this.addedPrescription.push(presObj);
              newPrescriptions.push(presObj);
            });
          }
        });
      }

      // 2. VITALS
      else if (titleLower.includes("vital")) {
        acceptedFields.forEach(field => {
          const vitalField = (field.label || "").toLowerCase();
          const value = field.value;
          if (!this.vitalsData) this.vitalsData = {};
          if (vitalField.includes("bp") || vitalField.includes("blood pressure")) {
            if (vitalField.includes("sys")) this.vitalsData.bP_Sys = parseInt(value) || value;
            else if (vitalField.includes("dia")) this.vitalsData.bP_Dia = parseInt(value) || value;
          } else if (vitalField.includes("pulse")) this.vitalsData.pulse = parseFloat(value) || value;
          else if (vitalField.includes("temp")) this.vitalsData.temp = parseFloat(value) || value;
          else if (vitalField.includes("resp")) this.vitalsData.resp_Rate = parseFloat(value) || value;
          else if (vitalField.includes("sugar")) {
            if (vitalField.includes("pre")) this.vitalsData.pre_Sugar = parseFloat(value) || value;
            else if (vitalField.includes("post")) this.vitalsData.post_Sugar = parseFloat(value) || value;
            else this.vitalsData.random_Sugar = parseFloat(value) || value;
          } else if (vitalField.includes("spo2")) this.vitalsData.spo2 = parseFloat(value) || value;
          else if (vitalField.includes("weight")) this.vitalsData.weight = parseFloat(value) || value;
          else if (vitalField.includes("height")) this.vitalsData.height = parseFloat(value) || value;
          newVitals.push({ field: vitalField, value });
        });
        if (resolvedDoctorId) {
          if (!this.vitalsData) this.vitalsData = {};
          this.vitalsData.performingDoctor = resolvedDoctorId;
        }
      }

      // 3. COMPLAINTS
      else if (titleLower.includes("complaint") || titleLower.includes("symptom")) {
        let currentComp: any = { visitId: this.visitId, performingDoctor: resolvedDoctorId };
        acceptedFields.forEach((field: any) => {
          const label = (field.label || "").toLowerCase();
          const val = field.value;
          if ((label === "complaint" || label === "symptom") && currentComp.complaintName) {
            this.finalizeComplaint(currentComp, newComplaints);
            currentComp = { visitId: this.visitId, performingDoctor: resolvedDoctorId };
          }
          if (label === "complaint" || label === "symptom") {
            currentComp.complaintName = val;
          } else if (label === "duration") {
            currentComp.duration = val;
          } else if (label === "period") {
            currentComp.period = val;
          } else if (label === "presenthistory") {
            // Strict match: only the 'presentHistory' label maps to presentHistory
            currentComp.presentHistory = (currentComp.presentHistory ? currentComp.presentHistory + ". " : "") + val;
          } else if (label === "notes") {
            // 'notes' is a SEPARATE field - do NOT merge into presentHistory
            currentComp.notes = (currentComp.notes ? currentComp.notes + ". " : "") + val;
          } else {
            // Any other unrecognised label goes to presentHistory as extra context
            currentComp.presentHistory = (currentComp.presentHistory ? currentComp.presentHistory + ". " : "") + field.label + ": " + val;
          }
        });
        this.finalizeComplaint(currentComp, newComplaints);
      }

      // 4. DIAGNOSIS
      else if (titleLower.includes("diagnosis")) {
        let currentDiag: any = { visitId: this.visitId, performingDoctor: resolvedDoctorId };
        acceptedFields.forEach((field: any) => {
          const label = (field.label || "").toLowerCase();
          const val = field.value;
          if (label === "diagnosis" && currentDiag.diagnosisName) {
            this.finalizeDiagnosis(currentDiag, newDiagnosis);
            currentDiag = { visitId: this.visitId, performingDoctor: resolvedDoctorId };
          }
          if (label === "diagnosis") currentDiag.diagnosisName = val;
          else if (label === "treatmentgiven" || label.includes("note") || label.includes("treatment")) {
            currentDiag.treatmentGiven = (currentDiag.treatmentGiven ? currentDiag.treatmentGiven + ". " : "") + val;
          } else {
            currentDiag.treatmentGiven = (currentDiag.treatmentGiven ? currentDiag.treatmentGiven + ". " : "") + field.label + ": " + val;
          }
        });
        this.finalizeDiagnosis(currentDiag, newDiagnosis);
      }

      // 5. INVESTIGATIONS
      else if (titleLower.includes("investigation") || titleLower.includes("lab")) {
        let currentInv: any = { visitId: this.visitId, performingDoctor: resolvedDoctorId };
        acceptedFields.forEach((field: any) => {
          const label = (field.label || "").toLowerCase();
          const val = field.value;
          // investigationService, testName, serviceName etc.
          const isServiceLabel = label === "investigationservice" || label.includes("test") || label.includes("name") || label.includes("service");
          if (isServiceLabel && currentInv.serviceName) {
            this.finalizeInvestigation(currentInv, newInvestigations);
            currentInv = { visitId: this.visitId, performingDoctor: resolvedDoctorId };
          }
          if (isServiceLabel) currentInv.serviceName = val;
          else if (label === "medicalpriority") currentInv.woPriority = val;
          else if (label === "outsidetest") currentInv.isOutsideLab = this.isT(val);
          else if (label === "providediscount") currentInv.isDiscount = this.isT(val);
          else if (label === "notes") {
            currentInv.notes = (currentInv.notes ? currentInv.notes + ". " : "") + val;
          } else {
            currentInv.notes = (currentInv.notes ? currentInv.notes + ". " : "") + (field.label + ": " + val);
          }
        });
        this.finalizeInvestigation(currentInv, newInvestigations);
      }

      // 6. FOLLOW-UP AGGREGATION
      // STRICT: Only process the 'follow_up' section — task_order_* sections are completely skipped.
      // Maps exactly what's visible on the FOLLOW UP card: followUpDate, followUpDoctor, followUpTreatment, followUpObservation
      else if (titleLower === "follow_up" || titleLower === "follow up") {
        let currentFollowUp: any = {};
        acceptedFields.forEach(f => {
          const l = (f.label || "").toLowerCase();
          const v = f.value;

          if ((l === "followupdoctor" && currentFollowUp.doctor) ||
            ((l === "followupdate" || l === "followup_date" || l.includes("date")) && currentFollowUp.date)) {
            this.finalizeFollowUp(currentFollowUp, newFollowUps);
            currentFollowUp = {};
          }

          if (l === "followupdoctor") {
            currentFollowUp.doctor = v.replace(/^doctor\s+/i, "").trim();
          } else if (l === "followupdate" || l === "followup_date" || l.includes("date")) {
            currentFollowUp.date = v;
          } else if (l === "followuptreatment" || l === "followup_treatment") {
            currentFollowUp.treatment = (currentFollowUp.treatment ? currentFollowUp.treatment + ". " : "") + v;
          } else if (l === "followupobservation" || l === "followup_observation") {
            currentFollowUp.observation = (currentFollowUp.observation ? currentFollowUp.observation + ". " : "") + v;
          }

          consolidatedAcceptedFields.push(f);
        });
        this.finalizeFollowUp(currentFollowUp, newFollowUps);
      }
      // task_order_*, high_risk, examination, and all other sections: NOT processed here
    });

    return {
      newPrescriptions,
      newComplaints,
      newDiagnosis,
      newInvestigations,
      newFollowUps,
      newVitals
    };
  }

  private finalizeComplaint(comp: any, newComplaints: any[]) {
    if (!comp.complaintName && !comp.presentHistory) return;
    const match = this.chiefComplaintList?.find(c =>
      c.name && comp.complaintName && c.name.toLowerCase().includes(String(comp.complaintName).toLowerCase())
    );
    comp.chiefComplaintId = match?.id || 0;
    this.addedComplaints.push(comp);
    newComplaints.push(comp);
  }

  private finalizeDiagnosis(diag: any, newDiagnosis: any[]) {
    if (!diag.diagnosisName) return;
    const match = this.patientDiagnosisList?.find(d =>
      d.name && diag.diagnosisName && d.name.toLowerCase().includes(String(diag.diagnosisName).toLowerCase())
    );
    diag.diagnosisId = match?.id || 0;
    this.addedDiagnosis.push(diag);
    newDiagnosis.push(diag);
  }

  private finalizeInvestigation(inv: any, newInvestigations: any[]) {
    if (!inv.serviceName && !inv.notes && !inv.woPriority) return;
    if (!inv.serviceName) inv.serviceName = "Investigation";

    const match = this.InvestigationList?.find(i =>
      (i.name && inv.serviceName && i.name.toLowerCase().includes(String(inv.serviceName).toLowerCase())) ||
      (i.concatName && inv.serviceName && i.concatName.toLowerCase().includes(String(inv.serviceName).toLowerCase()))
    );
    inv.serviceId = match?.id || 0;
    inv.services = match || { id: 0, name: inv.serviceName };
    this.addedInves.push(inv);
    newInvestigations.push(inv);
  }

  private finalizeFollowUp(follow: any, newFollowUps: any[]) {
    if (!follow.doctor && !follow.date && !follow.treatment && !follow.observation) return;

    const docName = follow.doctor || this.docId;
    const fDate = follow.date || new Date().toISOString();

    const followObj = {
      doctor: docName,
      date: fDate,
      visitId: this.visitId,
      inputJson: {
        Reason: follow.observation || follow.treatment || "",
        treatment: follow.treatment || "",
        Observation: follow.observation || "",
        Type: "Inhouse",
        Mode: false,
        Doctor: docName,
        Appointmentperiod: "1",
        Scheduled: "New",
        DateTime: fDate,
        Date: fDate
      }
    };

    this.addedfollowUp.push(followObj);
    newFollowUps.push(followObj);
  }


  /**
   * Builds the exact postAPIConverstion payload format from the EHR arrays
   * (both previously existing data AND newly added AI data)
   */
  private buildPostAPIConverstionPayload(): any {
    const patientInfo = this.visitLog?.[0]?.patientRegistration || {};
    const details: any = {


      patientVital: {
        vitalDto: this.vitalsData ? [{
          ...this.vitalsData,
          regId: this.regId,
          visitId: parseInt(this.visitId),
          tenantId: this.tenandId,
          branchId: this.branchId,
          createdBy: parseInt(this.userId)
        }] : [],
        fetusVitalDto: [],
        obstericsDto: []
      },
      patientMenstural: null,
      patientRefAppoinment: [],
      patientInvestigation: [],
      patientPrescription: [],
      patientObsterics: null,
      patientCurrentMedications: [],
      patientComplaints: (this.addedComplaints || [])
        .filter(x => x?.visitId == this.visitId)
        .map(e => ({
          complaint: {
            name: this.nameCheck(e?.chiefComplaintId, "comp") || e?.complaintName || e?.complaint?.name || "Complaint",
            code: null
          },
          duration: e.duration || null,
          period: e.period || null,
          notes: e.notes || null,
          presentHistory: e.presentHistory || null,
          performingDoctor: e.performingDoctor || null,
          performingNurse: null
        })),

      patientDiagnosis: (this.addedDiagnosis || [])
        .filter(x => x?.visitId == this.visitId)
        .map(e => ({
          diagnosis: {
            name: e?.diagnosisName || e?.diagnosis?.name || "Diagnosis",
            code: null
          },
          confidence: null,
          treatmentGiven: e.treatmentGiven || "",
          performingDoctor: e.performingDoctor || null,
          performingNurse: null

        })),

      visit: {
        patientRegistration: {
          firstname: patientInfo.firstname || null,
          age: patientInfo.age || null,
          dob: patientInfo.dob || null,
          mobile: patientInfo.mobile || null
        }
      }
    };

    this.addedPrescription?.filter(x => x?.visitId == this.visitId)?.forEach(e => {
      details.patientPrescription.push({
        medicine: {
          name: e?.presNameForQC || e?.medicine?.name || "Medicine",
          medicineCategory: { name: e?.categoryName || "" }
        },
        dosage: e.dosage || "",
        dosageunit: e.dosageunit || "",
        duration: e.days || 0,
        durationUnit: e.durationunit || "Days",
        frequency: e.frequency || "",
        takenAt: e.takenAt || "After Food",
        instructions: e.instructions || "",
        qty: parseInt(e.qty) || 0,
        mor: e.mor,
        aft: e.aft,
        eve: e.eve,
        night: e.night,
        performingDoctor: e.performingDoctor || null
      });
    });

    this.addedInves?.filter(x => x.visitId == this.visitId)?.forEach(e => {
      details.patientInvestigation.push({
        notes: e.notes || null,
        services: { name: e?.serviceName || e?.services?.name || "Investigation" },
        woPriority: (e.woPriority === "Urgent" || e.woPriority === "Emergency") ? 1 : 0,
        isOutsideLab: e.isOutsideLab || false,
        isDiscount: e.isDiscount || false,
        performingDoctor: e.performingDoctor || null
      });
    });

    this.addedfollowUp?.filter(x => x?.visitId == this.visitId)?.forEach(e => {
      const jsonStr = typeof e.inputJson === "string" ? e.inputJson : JSON.stringify(e.inputJson);
      if (!details.patientRefAppoinment.find(f => f.inputJson === jsonStr)) {
        details.patientRefAppoinment.push({
          doctorId: e?.doctor || this.docId,
          visitId: parseInt(this.visitId),
          inputJson: jsonStr
        });
      }
    });

    details.patientPrescription = details.patientPrescription.filter((v, i, a) => a.findIndex(t => t.medicine.name === v.medicine.name && t.dosage === v.dosage) === i);
    details.patientComplaints = details.patientComplaints.filter((v, i, a) => a.findIndex(t => t.complaint.name === v.complaint.name) === i);
    details.patientDiagnosis = details.patientDiagnosis.filter((v, i, a) => a.findIndex(t => t.diagnosis.name === v.diagnosis.name) === i);
    details.patientInvestigation = details.patientInvestigation.filter((v, i, a) => a.findIndex(t => t.services.name === v.services.name) === i);

    return details;
  }



  /**
   * Builds the exact postAPIConverstion payload format that the HomeopathyCasesheetSave API expects.
   * This is the format you see in the Network tab response after a successful save.
   */

  private async fetchRequiredMasterData(): Promise<void> {
    // These are already loaded when cards are expanded, but ensure they're available
    // If needed, call the same APIs that populate the dropdowns
    const promises: Promise<any>[] = [];

    if (!this.performDocList?.length) {
      promises.push(this.rolesService.list(
        `physicians/${this.tenandId}/${this.branchId}/clinicalActivePhysicians?referralType=1&isActive=true&isClinical=true`
      ).toPromise());
    }

    if (promises.length) {
      await Promise.all(promises);
    }
  }
  // convoAI end here

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    // convoAI start here
    if (this.isSpeechRecording) {
      this.audioSpeechService.stopStreaming();
    }
    this.stopConversationAIStageCycle();
    // convoAI end here
  }

  ngOnInit(): void {
    this.fetchTenantBasedList();
    this.getQuickAccessDatas();
    this.getEhrDatas();
    this.loadPatientbloodgroup();
    this.getpriorityDetails();
    // convoAI start here
    this.audioSpeechService.transcription$.pipe(takeUntil(this.unsubscribe$)).subscribe(update => {
      this.handleTranscriptionUpdate(update);
    });

    this.audioSpeechService.medicalData$.pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      this.processData(data);
      this.medicalDataSubject.next(data);
      // AI Suggestion data has started populating - keep the "Populating EHR" indicator up
      // until subscribeToAIComplete() confirms every section has finished loading.
      if (!this.isAIComplete) {
        this.isAISuggestionsPopulating = true;
      }
      if (this.isConversationAILoading && this.sections?.length) {
        this.conversationAIStageIndex = this.conversationAIStages.length - 1;
        this.stopConversationAILoader();
      }
      this.cdr.detectChanges();
    });

    this.subscribeToAIComplete();
    this.loadLanguages();


    this.audioSpeechService.isRecording$.pipe(takeUntil(this.unsubscribe$)).subscribe(status => {
      this.isSpeechRecording = status;
      if (status) {
        this.startConversationAIListeningStage();
      }
      if (!status && this.speechSilenceTimer) {
        clearTimeout(this.speechSilenceTimer);
      }
      this.cdr.detectChanges();
    });

    this.audioSpeechService.sessionStatus$.pipe(takeUntil(this.unsubscribe$)).subscribe(status => {
      this.sessionStatus = status;
      if (status === 'initializing') {
        this.sessionStatusText = 'Connecting...';
      } else if (status === 'connected') {
        this.sessionStatusText = 'Connected';
      } else {
        this.sessionStatusText = 'Disconnected';
      }
      this.cdr.detectChanges();
    });
    // convoAI end here

    const defaultSection = (this.fromPage == 'care-doctor-emr' || this.fromPage == 'patientDash' || this.fromPage == 'video-consultation') ? 'vitalsCard' : 'allergyCard';
    this.selectSection(defaultSection);
  }

  loadBloodGroupLists() {
    this.listapi.listsubcategory("bloodMst").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.bloodData = data;
    }, (error) => {

    }, () => {

    });
  }

  onChaneHistoryType(event) {
    const selectedId = event[0]?.data?.id;
    if (selectedId) {
      this.MedicalHistoryAllList = this.AllMedicalHistoryBackup.filter(
        (item) => item.typeId === selectedId
      );
    }
    else {
      this.MedicalHistoryAllList = this.AllMedicalHistoryBackup;
      this.patientmedicalHistoryForm?.get('historyType')?.setValue(null);
    }
  }

  fetchTenantBasedList() {
    const masterTypes = {
      masterTypes: ["ALLERGY_CATEGORY", "ALLERGY_REACTION"]
    }                                //from reason-master
    this.rolesService.create(`${environment.apiUrl}/tenants/${this.tenandId}/masterreason/${this.branchId}/getMultipleTenantBasedMasters`, masterTypes).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      const physioDropdownList = data.details;
      this.categoryList = physioDropdownList.filter(each => each.mrType === 'ALLERGY_CATEGORY' && each.isActive == true);
      this.reactionsList = physioDropdownList.filter(each => each.mrType === 'ALLERGY_REACTION' && each.isActive == true);

    })
  }


  getQuickAccessDatas() {
    this.rolesService.list(`CareSphere/GetDoctorFrequentData?docId=${this.docId}&tenantId=${this.tenandId}&branchId=${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      this.quickComplaints = res?.data?.chiefComp || [];
      this.quickDiagnoses = res?.data?.diagnosis || [];
      this.quickInvestigations = res?.data?.investigation || [];
    })
  }

  showPopup(flag, item) {
    this.currentPopupItem = item;
    if (flag == 'complaint') {
      this.patientcomplaintEditForm?.get('chiefComplaintId')?.setValue(this.currentPopupItem?.id);
      if (this.duplicateExistsComplain) {
        this.toaster.ForDanger('The complaint already exist');
        this.patientcomplaintEditForm.reset();
        this.duplicateExistsComplain = false;
        return;
      }
      this.showComplaintPopup = true;
    }
    else if (flag == 'diagnosis') {
      this.diagnosisForm?.get('diagnosisId')?.setValue(this.currentPopupItem?.id);
      this.diagnosisForm?.get('diagnosisName')?.setValue(this.currentPopupItem?.name);
      this.diagnosisForm?.get('updatedDiagnosisId')?.setValue(this.patientDiagnosisList?.find(e => e?.id == this.currentPopupItem?.id)?.updatedId);
      if (this.duplicateDiag) {
        this.toaster.ForDanger('The diagnosis already exist');
        this.diagnosisForm.reset();
        this.duplicateDiag = false;
        return;
      }
      this.showDiagnosisPopup = true;
    }
    else if (flag == 'investigation') {
      let found = this.addedInves?.filter(x =>
        x?.visitId == this.visitId &&
        x?.serviceId == this.currentPopupItem?.id
      );

      this.duplicateInves = found?.length > 0;

      if (this.duplicateInves) {
        this.toaster.ForDanger('The investigation already exist');
        this.duplicateInves = false;
        return;
      }

      this.investigationform?.get('serviceId')?.setValue(this.currentPopupItem?.id);
      this.investigationform?.get('serviceName')?.setValue(this.currentPopupItem?.name);

      this.showInvestigationPopup = true;
    }

  }

  onAllergyClick(): void {
    if (!this.allergySelect.optionsOpened) {
      this.allergySelect.focusToInput();

      setTimeout(() => {
        this.allergySelect.optionsOpen();
      });
    }
  }

  onMedHisDropdownClick(){
    if (!this.medHisDrop.optionsOpened) {
      this.medHisDrop.focusToInput();
      setTimeout(() => {
        this.medHisDrop.optionsOpen();
      });
    }
  }
  
  onSocialHabitsClick(){
    if (!this.socialHabitsDrop.optionsOpened) {
      this.socialHabitsDrop.focusToInput();
      setTimeout(() => {
        this.socialHabitsDrop.optionsOpen();
      });
    }
  }

  onCurrentMedicationClick(){
    if (!this.currMedDrop.optionsOpened) {
      this.currMedDrop.focusToInput();
      setTimeout(() => {
        this.currMedDrop.optionsOpen();
      });
    }
  }

  onCompDropdownClick(): void {
    if (!this.complaintSelect.optionsOpened) {
      this.complaintSelect.focusToInput();

      setTimeout(() => {
        this.complaintSelect.optionsOpen();
      });
    }
  }

  onFamHisDropdownClick(): void {
    if (!this.famHisDrop.optionsOpened) {
      this.famHisDrop.focusToInput();

      setTimeout(() => {
        this.famHisDrop.optionsOpen();
      });
    }
  }

  onDiagDropdownClick(): void {
    if (!this.diagSelect.optionsOpened) {
      this.diagSelect.focusToInput();

      setTimeout(() => {
        this.diagSelect.optionsOpen();
      }
      );
    }
  }

  onInvesDropdownClick(): void {
    // if (!this.invesSelect.optionsOpened) {
    //   this.invesSelect.onInputFocus();

    //   setTimeout(() => {
    this.invesSelect.open();
    //   }
    //   );
    // }
  }

  onPresciptionClick(): void {
    if (!this.medicineSelect.optionsOpened) {
      this.medicineSelect.focusToInput();

      setTimeout(() => {
        this.medicineSelect.optionsOpen();
      }
      );

    }
  }

  onFollowupClick(): void {
    if (!this.docSelect.optionsOpened) {
      this.docSelect.focusToInput();

      setTimeout(() => {
        this.docSelect.optionsOpen();
      });
    }
  }

  closePopup(flag) {
    if (flag == 'complaint') {
      this.showComplaintPopup = false;
    }
    else if (flag == 'diagnosis') {
      this.showDiagnosisPopup = false;
    }
    else if (flag == 'investigation') {
      this.showInvestigationPopup = false;
    }
    this.currentPopupItem = null;
  }

  currentPopupItem: any = {};
  showComplaintPopup: boolean = false;
  showDiagnosisPopup: boolean = false;
  showInvestigationPopup: boolean = false;

  getEhrDatas() {
    this.rolesService.list(`EHRCaseSheetMst/GetHomeopathyCasesheet?tenantId=${this.tenandId}&branchId=${this.branchId}&regId=${this.regId}&visitId=${this.visitId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((det: any) => {
      this.getAllEhrList(det);
    })
  }

  loadPatientbloodgroup() {

    this.rolesService.list(`patientClinicalMst/${this.tenandId}/${this.branchId}/getPatientClinicalMstById/${this.regId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if (data?.message == "No records found" || !data?.bloodMst) {
        this.bloodGroup = {};
      }
      else if (data?.bloodMst) {
        this.bloodGroup = data;
      }
    }, (error) => {
    }, () => {
    });
  }

  getAllEhrList(det) {
    const details = det?.details;
    this.vitalsData = details.patientVital?.vitalDto?.filter(x => x?.visitId == this.visitId)[0];
    this.tempVitalsData=this.vitalsData;
    if (!!this.vitalsData) {
      this.editVitals = true;
      this.vitalForms.patchValue(this.vitalsData);
    }
    else{
      this.vitalForms?.get('takenDatetime')?.setValue(new Date());
    }
    // if (!!details?.patientClinicalMst) {
    //   this.patientClinicalMst = details?.patientClinicalMst;
    //   if (!!this.patientClinicalMst && !!this.patientClinicalMst?.bloodGroupId) {
    //     this.bloodGroupId=this.patientClinicalMst?.bloodGroupId;
    //     this.editBlood = true;
    //   }
    // }
    if (details?.patientAllergy?.length > 0) {
      this.addedAllergies = details?.patientAllergy?.sort((a, b) => b?.visitId - a?.visitId);
    }
    if (details?.patientComplaints?.length > 0) {
      this.addedComplaints = details?.patientComplaints?.sort((a, b) => b?.visitId - a?.visitId);
      this.patientAddedComplaints = this.addedComplaints?.filter(c => c.visitId == 0)?.sort((a, b) => new Date(b?.createdDate).getTime() - new Date(a?.createdDate).getTime());
    }
    if (details?.patientDiagnosis?.length > 0) {
      this.addedDiagnosis = details?.patientDiagnosis?.sort((a, b) => b?.visitId - a?.visitId);
    }
    if (details?.patientInvestigation?.length > 0) {
      this.addedInves = details?.patientInvestigation?.sort((a, b) => b?.visitId - a?.visitId);
    }
    if (details?.patientPrescription?.length > 0) {
      this.addedPrescription = details?.patientPrescription?.sort((a, b) => b?.visitId - a?.visitId);
    }
    if (details?.patientSocialHabits?.length > 0) {
      this.addedSocialHabits = details?.patientSocialHabits?.sort((a, b) => b?.visitId - a?.visitId);
    }
    if (details?.patientCurrentMedications?.length > 0) {
      this.addedCurrentMedications = details?.patientCurrentMedications?.sort((a, b) => b?.visitId - a?.visitId);
    }
    if (details?.familyMedicalHistory?.length > 0) {
      this.addedFamilyHistories = details?.familyMedicalHistory?.sort((a, b) => b?.visitId - a?.visitId);
    }
    if (details?.medicalHistory?.length > 0) {
      this.addedMedicalHistories = details?.medicalHistory?.sort((a, b) => b?.visitId - a?.visitId);
    }
    if (details?.patientRefAppoinment?.length > 0) {
      details.patientRefAppoinment = details?.patientRefAppoinment?.filter(x => x?.careTaskType == 14)?.map(e => ({
        ...e,
        inputJson: JSON.parse(e?.inputJson)
      }));
      this.addedfollowUp = details.patientRefAppoinment?.sort((a, b) => b?.visitId - a?.visitId);
    }

  }

  // ===== Lab Report (EHR-embedded) =====
  loadLabReportData() {
    this.labResult.list(`labresultmst/getLabReportDet/${this.tenandId}/${this.branchId}/${this.regId}`)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.labReportFullData = data;
        this.labReportData = data?.filter(x => x.resultStatus == "Completed" || x.resultStatus == "In-Progress") || [];
      }, (error) => { });
  }

  labReportActiveButton(tab: string) {
    if (tab === 'LabOrderWise') {
      this.labReportIsOrderWise = true;
      this.labReportIsTestWise = false;
    } else if (tab === 'TestWise') {
      this.labReportShowHistory();
      this.labReportIsOrderWise = false;
      this.labReportIsTestWise = true;
    }
  }

  labReportShowHistory() {
    this.labResultSrvc.list(`labresultmst/vitalsTargetReport/${this.tenandId}/${this.branchId}/${this.regId}`)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.labReportShowHistoryHeaders = data?.returnValue;
        this.labReportGroupedData = this.labReportGroupBy(this.labReportShowHistoryHeaders);
      }, (error) => { });
  }

  labReportGetValue(det: any[], date: string): string {
    const record = det?.find(record => record.completedDate === date);
    return record ? record.labResultValue : '-';
  }

  labReportGroupBy(data): any[] {
    if (!data) { return []; }
    const flattenedData = data.flat();
    const grouped = flattenedData.reduce((result, currentItem) => {
      const key = currentItem.serviceId;
      if (!result[key]) {
        result[key] = {
          serviceId: key,
          serviceName: currentItem.serviceName,
          latestValue: currentItem.labResultValue,
          latestDate: currentItem.completedDate,
          det: []
        };
      }
      result[key].det.push(currentItem);
      if (new Date(currentItem.completedDate) > new Date(result[key].latestDate)) {
        result[key].latestValue = currentItem.labResultValue;
        result[key].latestDate = currentItem.completedDate;
      }
      return result;
    }, {});
    return Object.values(grouped);
  }

  labReportUniqueDates(): string[] {
    if (!this.labReportShowHistoryHeaders) { return []; }
    const datesSet = new Set<string>();
    for (const testArray of this.labReportShowHistoryHeaders) {
      for (const test of testArray) {
        datesSet.add(test.completedDate);
      }
    }
    return Array.from(datesSet);
  }

  labReportLoadGraph(det: any[]) {
    this.labReportSeriesList = [];
    const sorted = [...(det || [])].sort((a, b) => new Date(a.completedDate).getTime() - new Date(b.completedDate).getTime());
    const series = [];
    for (const d of sorted) {
      if (!!d.labResultValue && !isNaN(parseFloat(d.labResultValue)) && isFinite(parseFloat(d.labResultValue))) {
        series.push({ name: new Date(d.completedDate + "Z").toString(), value: d.labResultValue.toString() });
      }
    }
    this.labReportSeriesList.push({ name: "Value", series });
    this.labReportChartShow = true;
  }

  labReportCloseGraph() {
    this.labReportChartShow = false;
  }

  labReportView(x) {
    localStorage.setItem('tenantId', x.tenantId);
    localStorage.setItem('branchId', x.branchId);
    localStorage.setItem('Printselection', JSON.stringify([]));
    localStorage.setItem('removedPrintselection', JSON.stringify([]));
    this.router.navigate(['/pages/lab/labresultentryprint', x.billId, x.workOrderId], { queryParams: { Isprintall: 'Y', isPatientPortal: true } });
  }

  labReportDownload(x) {
    localStorage.setItem('tenantId', x.tenantId);
    localStorage.setItem('branchId', x.branchId);
    localStorage.setItem('Printselection', JSON.stringify([]));
    localStorage.setItem('removedPrintselection', JSON.stringify([]));
    this.router.navigate(['/pages/lab/labresultentryprint', x.billId, x.workOrderId, 'download']);
  }

  labReportPrevClicked() {
    if (this.labReportP > 1) { this.labReportP = this.labReportP - 1; }
  }

  labReportNextClicked() {
    if (this.labReportP < Math.ceil((this.labReportData?.length || 0) / 10)) { this.labReportP = this.labReportP + 1; }
  }

  // ===== Vitals History popup (Grid View + Graphical View) =====
  openVitalsHistory() {
    this.vitalsHistoryOpen = true;
    this.vitalsHistoryTab = 'grid';
    if (this.vitalsHistoryLoadedForReg !== this.regId) {
      this.loadVitalsHistory();
    } else {
      this.buildVitalsHistorySeries();
    }
  }

  closeVitalsHistory() {
    this.vitalsHistoryOpen = false;
  }

  setVitalsHistoryTab(tab: 'grid' | 'graph') {
    this.vitalsHistoryTab = tab;
    if (tab === 'graph') {
      this.buildVitalsHistorySeries();
    }
  }

  setVitalsHistoryMetric(id: string) {
    this.vitalsHistoryMetric = id;
    this.buildVitalsHistorySeries();
  }

  loadVitalsHistory() {
    this.vitalsHistoryLoading = true;
    const det = {
      tenantId: this.tenandId,
      branchId: this.branchId,
      regId: this.regId,
      skip: 0,
      take: 200,
      pageName: 'vitals',
      branchFlag: true
    };
    this.rolesService.create(`${environment.apiUrl}/ehrOptimizationController/${this.tenandId}/${this.branchId}/GetAllVitals`, det)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((datas: any) => {
        this.vitalsHistoryRows = (datas?.details || []).slice().sort((a, b) => new Date(a?.date).getTime() - new Date(b?.date).getTime());
        this.vitalsHistoryLoadedForReg = this.regId;
        this.vitalsHistoryLoading = false;
        this.buildVitalsHistorySeries();
      }, (error) => { this.vitalsHistoryLoading = false; });
  }

  private vitalsHistoryGlucoseCell(r: any): string {
    const parts = [];
    if (r?.preSugar !== null && r?.preSugar !== undefined && r?.preSugar !== '') { parts.push(`${r.preSugar}(F)`); }
    if (r?.postSugar !== null && r?.postSugar !== undefined && r?.postSugar !== '') { parts.push(`${r.postSugar}(PP)`); }
    if (r?.randomSugar !== null && r?.randomSugar !== undefined && r?.randomSugar !== '') { parts.push(`${r.randomSugar}(R)`); }
    return parts.length ? parts.join(', ') : '-';
  }

  private vitalsHistoryIsNum(v: any): boolean {
    return v !== null && v !== undefined && v !== '' && !isNaN(parseFloat(v)) && isFinite(parseFloat(v));
  }

  private vitalsHistoryPoint(r: any, value: any) {
    return { name: new Date(r?.date).toString(), value: parseFloat(value) };
  }

  vitalsHistoryHasSeries(): boolean {
    return !!(this.vitalsHistorySeries && this.vitalsHistorySeries.some(s => s && s.series && s.series.length));
  }

  private buildVitalsHistorySeries() {
    const rows = this.vitalsHistoryRows || [];
    const series = [];
    switch (this.vitalsHistoryMetric) {
      case 'spo2':
        series.push({ name: 'SpO2', series: rows.filter(r => this.vitalsHistoryIsNum(r?.spo2)).map(r => this.vitalsHistoryPoint(r, r.spo2)).slice(-8) });
        break;
      case 'temp':
        series.push({ name: 'Temperature', series: rows.filter(r => this.vitalsHistoryIsNum(r?.temp)).map(r => this.vitalsHistoryPoint(r, r.temp)).slice(-8) });
        break;
      case 'pulse':
        series.push({ name: 'Pulse', series: rows.filter(r => this.vitalsHistoryIsNum(r?.pulse)).map(r => this.vitalsHistoryPoint(r, r.pulse)).slice(-8) });
        break;
      case 'respRate':
        series.push({ name: 'Respiration', series: rows.filter(r => this.vitalsHistoryIsNum(r?.respRate)).map(r => this.vitalsHistoryPoint(r, r.respRate)).slice(-8) });
        break;
      case 'glucose':
        series.push({ name: 'Pre-Meal', series: rows.filter(r => this.vitalsHistoryIsNum(r?.preSugar)).map(r => this.vitalsHistoryPoint(r, r.preSugar)).slice(-8) });
        series.push({ name: 'Post-Meal', series: rows.filter(r => this.vitalsHistoryIsNum(r?.postSugar)).map(r => this.vitalsHistoryPoint(r, r.postSugar)).slice(-8) });
        series.push({ name: 'Random', series: rows.filter(r => this.vitalsHistoryIsNum(r?.randomSugar)).map(r => this.vitalsHistoryPoint(r, r.randomSugar)).slice(-8) });
        break;
      case 'fetusHeartRate':
        series.push({ name: 'Fetal Heart Rate', series: rows.filter(r => this.vitalsHistoryIsNum(r?.fetusHeartRate)).map(r => this.vitalsHistoryPoint(r, r.fetusHeartRate)).slice(-8) });
        break;
      case 'bp':
      default:
        series.push({ name: 'Systolic', series: rows.filter(r => this.vitalsHistoryIsNum(r?.bpSys)).map(r => this.vitalsHistoryPoint(r, r.bpSys)).slice(-8) });
        series.push({ name: 'Diastolic', series: rows.filter(r => this.vitalsHistoryIsNum(r?.bpDia)).map(r => this.vitalsHistoryPoint(r, r.bpDia)).slice(-8) });
        break;
    }
    this.vitalsHistorySeries = series;
  }

  // ===== Radiology (EHR-embedded) =====
  loadRadiologyData() {
    this.radiologySrvc.getById(`${environment.apiUrl}/AtchDet/${this.tenandId}/${this.branchId}/${this.regId}`)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.radiologyFilesDet = data?.filter(d => d.category == "Radiology") || [];
        this.radiologyFullData = data?.filter(d => d.category == "Radiology") || [];
      }, (error) => { });
  }

  radiologyDownload(x) {
    const tId = x?.tenantId || this.tenandId;
    const bId = x?.branchId || this.branchId;
    this.radiologySrvc.create(`${environment.apiUrl}/AtchDet/${tId}/${bId}/download`, x)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.downloadFileRes(data, x.fileName);
      }, (error) => { });
  }

  radiologyView(det) {
    this.radiologyViewData = det;
    const tId = det?.tenantId || this.tenandId;
    const bId = det?.branchId || this.branchId;
    this.radiologySrvc.create(`${environment.apiUrl}/AtchDet/${tId}/${bId}/download`, det)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.radiologyImgName = 'data:image/jpeg;base64,' + data;
        this.radiologyImgView = true;
      }, (error) => { });
  }

  radiologyImgCancel() {
    this.radiologyImgView = false;
  }

  radiologyPrevClicked() {
    if (this.radiologyP > 1) { this.radiologyP = this.radiologyP - 1; }
  }

  radiologyNextClicked() {
    if (this.radiologyP < ((this.radiologyFilesDet?.length || 0) / 10)) { this.radiologyP = this.radiologyP + 1; }
  }

  // ===== Triage Captures (EHR-embedded, video-consultation) =====
  // General Examination/ECG/Fetal Doppler/Stethoscope tabs all read from the
  // same WoundCareAttachmentList response (each just filters a different
  // subcategory client-side) -- cached per regId so switching between those
  // tabs re-filters in memory instead of re-issuing the same API call.
  private triageAttachmentsAll$: Observable<any[]> | null = null;
  private triageAttachmentsLoadedForReg: string = null;

  private loadAllTriageAttachments(): Observable<any[]> {
    if (this.triageAttachmentsAll$ && this.triageAttachmentsLoadedForReg === this.regId) {
      return this.triageAttachmentsAll$;
    }
    const payload = {
      fromDate: null,
      toDate: null,
      tenantId: this.tenandId,
      category: 'vitals',
      firstName: this.curDetPat?.patFiName,
      mobile: this.curDetPat?.mobile,
      searchType: 'All'
    };
    this.triageAttachmentsLoadedForReg = this.regId;
    this.triageAttachmentsAll$ = this.radiologySrvc.create(`${environment.apiUrl}/WoundCare/WoundCareAttachmentList`, payload)
      .pipe(
        map((data: any) => data?.details || []),
        // Don't let a transient failure poison the cache for the rest of the
        // session -- clear it so the next tab click retries instead of every
        // later tab immediately replaying this same error.
        catchError(err => { this.triageAttachmentsAll$ = null; return throwError(() => err); }),
        shareReplay(1),
      );
    return this.triageAttachmentsAll$;
  }

  private loadTriageAttachments(subCategory: string): Observable<any[]> {
    return this.loadAllTriageAttachments().pipe(map(list => list.filter(d => d?.subcategory === subCategory)));
  }

  loadGeneralExaminationData() {
    this.loadTriageAttachments('General Examination').pipe(takeUntil(this.unsubscribe$)).subscribe((list) => {
      this.generalExamFilesDet = list;
    }, () => { this.generalExamFilesDet = []; });
  }

  loadEcgData() {
    this.loadTriageAttachments('ECG Medigraphy').pipe(takeUntil(this.unsubscribe$)).subscribe((list) => {
      this.ecgFilesDet = list;
    }, () => { this.ecgFilesDet = []; });
  }

  loadFetalDopplerData() {
    this.loadTriageAttachments('FetalDoppler').pipe(takeUntil(this.unsubscribe$)).subscribe((list) => {
      this.fetalDopplerFilesDet = list;
    }, () => { this.fetalDopplerFilesDet = []; });
  }

  loadStethoscopeData() {
    this.loadTriageAttachments('Stethoscope').pipe(takeUntil(this.unsubscribe$)).subscribe((list) => {
      this.stethoscopeFilesDet = list;
    }, () => { this.stethoscopeFilesDet = []; });
  }

  isImageAttachment(fileName: string): boolean {
    return /\.(jpg|jpeg|png)$/i.test(fileName || '');
  }

  isVideoAttachment(fileName: string): boolean {
    return /\.(webm|mp4)$/i.test(fileName || '');
  }

  isAudioAttachment(fileName: string): boolean {
    return /\.(wav|mp3|m4a|ogg)$/i.test(fileName || '');
  }

  /** Maps a filename extension to the MIME type that actually matches its content, for attachments whose real format can't be inferred from extension alone (e.g. Stethoscope recordings, which are audio despite sometimes carrying a .webm extension shared with genuine video attachments). */
  private audioMimeTypeForFileName(fileName: string): string {
    const f = fileName || '';
    if (/\.mp3$/i.test(f)) return 'audio/mpeg';
    if (/\.m4a$/i.test(f)) return 'audio/mp4';
    if (/\.ogg$/i.test(f)) return 'audio/ogg';
    if (/\.webm$/i.test(f)) return 'audio/webm';
    return 'audio/wav';
  }

  isEcgAttachment(fileName: string): boolean {
    return /\.json$/i.test(fileName || '');
  }

  private base64ToBlob(base64: string, mimeType: string): Blob {
    const binary = window.atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return new Blob([bytes], { type: mimeType });
  }

  private revokeTriageBlobUrl(): void {
    if (this.currentTriageBlobUrl) {
      URL.revokeObjectURL(this.currentTriageBlobUrl);
      this.currentTriageBlobUrl = null;
    }
  }

  // The list endpoint returns each item's "file" as an empty string -- the actual
  // base64 content has to be fetched separately, same as Radiology's AtchDet download.
  // Renders the fetched content inline (image/video/audio/ECG) instead of only
  // offering a download, so the doctor can review the triage capture in place.
  viewTriageAttachment(x) {
    const tId = x?.tenantId || this.tenandId;
    const bId = x?.branchId || this.branchId;
    this.radiologySrvc.create(`${environment.apiUrl}/AtchDet/${tId}/${bId}/download`, x)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        if (this.isImageAttachment(x?.fileName)) {
          this.triageAttachmentImgName = 'data:image/jpeg;base64,' + data;
          this.triageAttachmentImgView = true;
        } else if (x?.subcategory === 'Stethoscope' || this.isAudioAttachment(x?.fileName)) {
          // Stethoscope recordings are audio-only even when their extension is
          // .webm (shared with genuine video attachments like General
          // Examination/ECG Medigraphy) -- checking the subcategory first,
          // ahead of the extension-based video check below, keeps them out of
          // the <video> branch regardless of which codec/extension they landed on.
          this.revokeTriageBlobUrl();
          const mimeType = this.audioMimeTypeForFileName(x?.fileName);
          this.currentTriageBlobUrl = URL.createObjectURL(this.base64ToBlob(data, mimeType));
          this.triageAttachmentAudioUrl = this.sanitizer.bypassSecurityTrustUrl(this.currentTriageBlobUrl);
          this.triageAttachmentAudioView = true;
        } else if (this.isVideoAttachment(x?.fileName)) {
          this.revokeTriageBlobUrl();
          const mimeType = /\.mp4$/i.test(x?.fileName || '') ? 'video/mp4' : 'video/webm';
          this.currentTriageBlobUrl = URL.createObjectURL(this.base64ToBlob(data, mimeType));
          this.triageAttachmentVideoUrl = this.sanitizer.bypassSecurityTrustUrl(this.currentTriageBlobUrl);
          this.triageAttachmentVideoView = true;
        } else if (this.isEcgAttachment(x?.fileName)) {
          // The download endpoint may return JSON attachments as plain text
          // (unlike binary types, which come back base64-encoded) -- try both.
          // TextDecoder (not the legacy escape/decodeURIComponent trick) is used
          // to turn the base64-decoded bytes back into text reliably.
          let json: any = null;
          try {
            json = JSON.parse(data);
          } catch (e1) {
            try {
              const binary = window.atob(data);
              const bytes = new Uint8Array(binary.length);
              for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
              json = JSON.parse(new TextDecoder('utf-8').decode(bytes));
            } catch (e2) {
              json = null;
            }
          }
          if (json && Array.isArray(json.samples)) {
            this.triageAttachmentEcgSamples = json.samples;
            this.triageAttachmentEcgView = true;
          } else {
            this.downloadFileRes(data, x.fileName);
          }
        } else {
          this.downloadFileRes(data, x.fileName);
        }
      }, () => { });
  }

  downloadTriageAttachment(x) {
    const tId = x?.tenantId || this.tenandId;
    const bId = x?.branchId || this.branchId;
    this.radiologySrvc.create(`${environment.apiUrl}/AtchDet/${tId}/${bId}/download`, x)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.downloadFileRes(data, x.fileName);
      }, () => { });
  }

  triageAttachmentVideoCancel() {
    this.triageAttachmentVideoView = false;
    // Nulling the url (not just the view flag) makes *ngIf tear the <video>
    // down, which is what actually stops playback -- the overlay hiding via
    // CSS alone leaves the element mounted and playing in the background.
    this.triageAttachmentVideoUrl = null;
    this.revokeTriageBlobUrl();
  }

  triageAttachmentAudioCancel() {
    this.triageAttachmentAudioView = false;
    this.triageAttachmentAudioUrl = null;
    this.revokeTriageBlobUrl();
  }

  triageAttachmentEcgCancel() {
    this.triageAttachmentEcgView = false;
  }

  triageAttachmentImgCancel() {
    this.triageAttachmentImgView = false;
  }

  selectTopTab(tab: string) {
    this.activeTopTab = tab;
    if (tab === 'pastRecords') {
      this.showPastRecord();
    }
  }

  selectSection(cardKey: string) {
    this.activeSection = cardKey;
    this.openComplaintCard = false;
    this.openVitals = false;
    this.openAllergyCard = false;
    this.openFamilyCard = false;
    this.openSocialHabits = false;
    this.openCurrentMedication = false;
    this.openMedicalHistoryCard = false;
    this.openDiagnosisCard = false;
    this.openInvestigationCard = false;
    this.openPrescriptionCard = false;
    this.openFollowupCard = false;
    if (cardKey === 'labReportCard') {
      this.loadLabReportData();
      return;
    }
    if (cardKey === 'radiologyCard') {
      this.loadRadiologyData();
      return;
    }
    if (cardKey === 'generalExaminationCard') {
      this.loadGeneralExaminationData();
      return;
    }
    if (cardKey === 'ecgCard') {
      this.loadEcgData();
      return;
    }
    if (cardKey === 'fetalDopplerCard') {
      this.loadFetalDopplerData();
      return;
    }
    if (cardKey === 'stethoscopeCard') {
      this.loadStethoscopeData();
      return;
    }
    this.toggleCard(cardKey);
  }

  toggleCard(card) {
    if (card === 'complaintCard') {
      this.openComplaintCard = !this.openComplaintCard;
      if (this.openComplaintCard) {
        this.loadPatientComplaint();
      }

    }
    // else if (card == 'bloodGroup') {
    //   this.openBloodGroupCard = !this.openBloodGroupCard;
    //   if (this.openBloodGroupCard) {
    //     this.loadBloodGroupLists();
    //   }
    // }
    else if (card === 'vitalsCard') {
      this.openVitals = !this.openVitals;
    }
    else if (card === 'allergyCard') {
      this.openAllergyCard = !this.openAllergyCard;
      if (this.openAllergyCard) {
        this.loadAllergiesMaster();
      }
    }
    else if (card === 'familyCard') {
      this.openFamilyCard = !this.openFamilyCard;
      if (this.openFamilyCard) {
        this.medicalHist();
      }
    }

    else if (card === 'socialHabitsCard') {
      this.openSocialHabits = !this.openSocialHabits;
      if (this.openSocialHabits) {
        this.LoadSocialHabits();
      }
    }
    else if (card == 'currentMedicationCard') {
      this.openCurrentMedication = !this.openCurrentMedication;
      if (this.openCurrentMedication) {
        this.loadMedicine();
      }
    }

    else if (card == 'medicalHistoryCard') {
      this.openMedicalHistoryCard = !this.openMedicalHistoryCard;
      if (this.openMedicalHistoryCard) {
        this.medicalHist();
      }
    }
    else if (card === 'diagnosisCard') {
      this.openDiagnosisCard = !this.openDiagnosisCard;
      if (this.openDiagnosisCard) {
        this.DiagnosisMasterList();
      }
    }
    else if (card === 'investigationCard') {
      this.openInvestigationCard = !this.openInvestigationCard;
      if (this.openInvestigationCard) {
        this.loadPatientInvestigations();
      }
    }
    else if (card === 'prescriptionCard') {
      this.openPrescriptionCard = !this.openPrescriptionCard;

      if (this.openPrescriptionCard) {
        this.loadFavoritePrescriptionData();
        this.fetchstockmedicineDetails();
      }

    }
    else if (card === 'followupCard') {
      this.openFollowupCard = !this.openFollowupCard;
      if (this.openFollowupCard) {
        this.loadlog();
        this.loadPhy();
      }
    }
  }

  openForm(section) {
    if (section === 'complaint') {
      this.showComplaintForm = true;
    }
    else if (section === 'vitals') {
      this.showVitalsForm = true;
    }
    else if (section === 'allergy') {
      this.showAllergyForm = true;
    }
    else if (section === 'family') {
      this.showFamilyForm = true;
    }
    else if (section === 'socialHabits') {
      this.showSocialHabitsForm = true;
    }
    else if (section === 'currentMedication') {
      this.showCurrentMedicationForm = true;
    }
    else if (section === 'diagnosis') {
      this.showDiagnosisForm = true;
    } else if (section === 'investigation') {
      this.showInvestigationForm = true;
    } else if (section === 'prescription') {
      this.showPrescriptionForm = true;
    }
    else if (section === 'followup') {
      this.showFollowupForm = true;
    }
    else if (section === 'medicalHistory') {
      this.showMedicalHistoryForm = true;
    }

  }

  onSearch(event: any) {

    this.name = event?.target?.value || '';
    this.skip = 0;
    this.InvestigationList = [];

    this.loadPatientInvestigations();
  }
  loadMore() {

    this.skip += this.take;
    this.loadPatientInvestigations();

  }

  LoadSocialHabits(): void {

    if(this.socialHabitsAllList?.length > 0) return;
    this.socialSrvc.list("socialhabits/" + this.tenandId + '/' + this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((datasocialHabitsAllList: any) => {
      this.socialHabitsAllList = datasocialHabitsAllList.value;
    }, (error) => {
    }, () => {
    });
  }

  loadPatientComplaint(): void {
    if (this.chiefComplaintList?.length > 0) return;
    // if (this.docId != null && this.docId != undefined && !!this.regId && !!this.visitId) {
    const docId=!!this.docId ? this.docId : '0'
      this.rolesService.list("patientcomplaint/" + this.tenandId + '/' + this.branchId + '/' + this.regId + '/' + this.visitId + '/GetPaitentComplaintsDatasWithMaster/' + docId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.chiefComplaintList = data.masterData.filter(x => x.isActive == true);
      })
    // }
  }

  checkDup(event, flag) {
    if (!!event[0]?.data) {
      if (flag == 'comp') {
        let found = this.addedComplaints?.filter(x =>
          x?.visitId == this.visitId &&
          x?.chiefComplaintId == event[0]?.data?.id
        );

        if (found?.length > 0 && this.compEdit) {
          if (found[0]?.chiefComplaintId == this.compEditData?.chiefComplaintId) {
            this.duplicateExistsComplain = false;
          } else {
            this.duplicateExistsComplain = true;
          }
        }
        else if (found?.length > 0) {
          this.duplicateExistsComplain = true;
        }
        else {
          this.duplicateExistsComplain = false;
        }
      }
      else if (flag == 'allergy') {
        let found = this.addedAllergies?.filter(x =>
          x?.visitId == this.visitId &&
          x?.allergyId == event[0]?.data?.id
        );

        if (found?.length > 0 && this.allergyEdit) {
          if (found[0]?.allergyId == this.allergyEditData?.allergyId) {
            this.duplicateAllergy = false;
          } else {
            this.duplicateAllergy = true;
          }
        }
        else if (found?.length > 0) {
          this.duplicateAllergy = true;
        }
        else {
          this.duplicateAllergy = false;
        }
      }
      else if (flag == 'diag') {
        this.diagnosisForm.controls['diagnosisName'].setValue(event[0].data.name);
        this.diagnosisForm.controls['diagnosisId'].setValue(event[0].data.id);
        this.diagnosisForm.controls['updatedDiagnosisId'].setValue(event[0].data.updatedId);

        let found = this.addedDiagnosis?.filter(x =>
          x?.visitId == this.visitId &&
          x?.diagnosisId == event[0]?.data?.id
        );

        if (found?.length > 0 && this.diagEdit) {
          if (found[0]?.diagnosisId == this.diagEditData?.diagnosisId) {
            this.duplicateDiag = false;
          } else {
            this.duplicateDiag = true;
          }
        }
        else if (found?.length > 0) {
          this.duplicateDiag = true;
        }
        else {
          this.duplicateDiag = false;
        }
      }
      else if (flag == 'socialHabits') {
        let found = this.addedSocialHabits?.filter(x =>
          x?.visitId == this.visitId &&
          x?.socialHabitsId == event[0]?.data?.id
        );

        if (found?.length > 0 && this.socialHabitEdit) {
          if (found[0]?.socialHabitsId == this.socialHabitEditData?.socialHabitsId) {
            this.duplicateSocialHabit = false;
          } else {
            this.duplicateSocialHabit = true;
          }
        }
        else if (found?.length > 0) {
          this.duplicateSocialHabit = true;
        }
        else {
          this.duplicateSocialHabit = false;
        }
      }
      else if (flag == 'familyHistory') {
        let found = this.addedFamilyHistories?.filter(x => x.visitId == this.visitId &&
          x?.medicalHistoryId == event[0]?.data?.id &&
          x?.relationshipId == event[0]?.data?.relationshipId
        );

        if (found?.length > 0 && this.familyHisEdit) {
          if (found[0]?.medicalHistoryId == this.familyHistoryEditData?.medicalHistoryId && found[0]?.relationshipId == this.familyHistoryEditData?.relationshipId) {
            this.duplicateFamHis = false;
          } else {
            this.duplicateFamHis = true;
          }
        }
        else if (found?.length > 0) {
          this.duplicateFamHis = true;
        }
        else {
          this.duplicateFamHis = false;
        }

      }
      else if (flag == 'medHis') {
        const list = this.gender?.toLocaleLowerCase()?.trim() == 'male' ? this.HistoryMaleType : this.HistoryTypeList
        const val = list?.find((li) => { return li?.id == event[0]?.data?.typeId; })?.id;
        this.patientmedicalHistoryForm?.get('historyType')?.setValue(val);
        let found = this.addedMedicalHistories?.filter(x => x.visitId == this.visitId &&
          x?.medicalHistoryId == event[0]?.data?.id
        );

        if (found?.length > 0 && this.medHisEdit) {
          if (found[0]?.medicalHistoryId == this.medHistoryEditData?.medicalHistoryId) {
            this.duplicateMedicalHistory = false;
          } else {
            this.duplicateMedicalHistory = true;
          }
        }
        else if (found?.length > 0) {
          this.duplicateMedicalHistory = true;
        }
        else {
          this.duplicateMedicalHistory = false;
        }
      }
      else if (flag == 'currMed') {
        let found = this.addedCurrentMedications?.filter(x =>
          x?.visitId == this.visitId &&
          x?.medicineId == event[0]?.data?.id
        );

        if (found?.length > 0 && this.currMedEdit) {
          if (found[0]?.medicineId == this.currMedEditData?.medicineId) {
            this.duplicateCurrMed = false;
          } else {
            this.duplicateCurrMed = true;
          }
        }
        else if (found?.length > 0) {
          this.duplicateCurrMed = true;
        }
        else {
          this.duplicateCurrMed = false;
        }
      }
    }
  }

  checkDupInves(event) {
    this.investigationform.controls['serviceName'].setValue(event?.concatName);

    let found = this.addedInves?.filter(x =>
      x?.visitId == this.visitId &&
      x?.serviceId == event?.id
    );

    if (found?.length > 0 && this.invesEdit) {
      if (found[0]?.serviceId == this.invesEditData?.serviceId) {
        this.duplicateInves = false;
      } else {
        this.duplicateInves = true;
      }
    }
    else if (found?.length > 0) {
      this.duplicateInves = true;
    }
    else {
      this.duplicateInves = false;
    }
  }

  loadFavoritePrescriptionData(allFavorites?: boolean): void {
    const physicianId = allFavorites ? null : this.docId;
    this.favoriteMedicineSrvc.list(`favoritemedicine/${this.tenandId}/${this.branchId}?physicianId=${physicianId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if (!allFavorites && this.fromPage == 'video-consultation' && !(data?.value?.length > 0)) {
        this.loadFavoritePrescriptionData(true);
        return;
      }
      this.favoritesList = data?.value || [];
      this.setValues(this.favoritesList);
    }, (error) => {

    }, () => {

    });
  }

  setValues(data) {
    if (data.length > 0) {
      let favdata = data;
      var groups = new Set(favdata.map(item => item.name)),
        results = [];
      groups.forEach(g => {
        var meddata = favdata.filter(i => i.name === g);
        results.push({
          name: g,
          values: meddata,
          medicinename: meddata.map(i => { return i.medicine.name })
        }
        )
      })
      this.favoritesList = [];
      this.favoritesList = results;
    }
    else {
      this.favoritesList = [];
    }
  }

  calculateDate(data) {
    if (!!data) {
      var result = data.match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+|)/g);
      if (result[1]?.toLowerCase() == 'd') {
        this.patientcomplaintEditForm.controls['period'].setValue('days');
      }
      else if (result[1]?.toLowerCase() == 'w') {
        this.patientcomplaintEditForm.controls['period'].setValue('weeks');
      }
      else if (result[1]?.toLowerCase() == 'm') {
        this.patientcomplaintEditForm.controls['period'].setValue('months');
      }
      else if (result[1]?.toLowerCase() === 'y') {
        this.patientcomplaintEditForm.controls['period'].setValue('year');
      }
      this.patientcomplaintEditForm.controls['duration'].setValue(result[0]);
      this.patientcomplaintEditForm.controls['selecteddays'].setValue(data);
      this.patientcomplaintEditForm.controls['extraOption'].setValue(data);
    }
  }

  nameCheck(id, flag) {
    if (!!id) {
      if (flag == 'comp') { return this.chiefComplaintList?.find(e => e?.id == id)?.name }
      else if (flag == 'allergy') { return this.allergyAllList.find(e => e?.id == id)?.name }
      else if (flag == 'currMed') { return this.MedicineListForCurr.find(e => e?.id == id)?.name }
      else if (flag == 'socialHabits') { return this.socialHabitsAllList.find(e => e?.id == id)?.name }
      else if (flag == 'familyHistory') { return this.medicalHistoryMasterList.find(e => e?.id == id)?.name }
      else if (flag == 'bloodGroup') { return this.bloodData.find(e => e?.id == id)?.name }
    } return '';
  }

  getSocialHabitStatusName(id) {
    return this.socialHabitStatusList?.find(s => s.id == id)?.name || '-';
  }

  getHistoryTypeName(id) {
    const list = this.gender?.toLowerCase()?.trim() == 'male' ? this.HistoryMaleType : this.HistoryTypeList;
    return list?.find(h => h.id == id)?.Name || '-';
  }

  getRelationshipName(id) {
    return (this.relationshipList)?.find(r => r.RelationshipId == id)?.Name || '-';
  }

  getRelationshipExtensionName(id) {
    return this.extensionList?.find(e => e.id == id)?.name || '-';
  }

  deletePopup(flag, x) {
    this.deleteTable(flag, x)
  }

  confirmDeleteTarget: { flag: string, index: number } = null;

  requestDelete(flag: string, index: number) {
    this.confirmDeleteTarget = { flag, index };
  }

  cancelDelete() {
    this.confirmDeleteTarget = null;
  }

  confirmDeleteYes() {
    if (this.confirmDeleteTarget) {
      this.deletePopup(this.confirmDeleteTarget.flag, this.confirmDeleteTarget.index);
      this.toaster.ForSuccess('Record deleted successfully');
    }
    this.confirmDeleteTarget = null;
  }

  deleteTable(flag, det) {
    if (det == 0 || det > 0) {
      if (flag == 'comp') {
        if (det !== -1) {
          this.addedComplaints.splice(det, 1);
          this.resetComp();
        }
      }
      else if (flag == 'medHis') {
        if (det != -1) {
          this.addedMedicalHistories?.splice(det, 1);
          this.resetMedHis();
        }
      }
      else if (flag == 'currMed') {
        if (det != -1) {
          this.addedCurrentMedications?.splice(det, 1);
          this.resetCurrMed();
        }
      }
      else if (flag == 'familyHistory') {
        if (det !== -1) {
          this.addedFamilyHistories.splice(det, 1);
          this.resetFamilyHist();
        }
      }
      else if (flag == 'socialHabits') {
        if (det !== -1) {
          this.addedSocialHabits.splice(det, 1);
          this.resetSocialHabits();
        }
      }
      else if (flag == 'allergy') {
        if (det !== -1) {
          this.addedAllergies.splice(det, 1);
          this.resetAllergy();
        }
      }
      else if (flag == 'follow') {
        if (det !== -1) {
          this.addedfollowUp.splice(det, 1);
          this.resetFollow();
        }
      }
      else if (flag == 'diag') {
        if (det !== -1) {
          this.addedDiagnosis.splice(det, 1);
          this.resetDiag();
        }
      }
      else if (flag == 'Inves') {
        if (det !== -1) {
          this.addedInves.splice(det, 1);
          this.resetDiag();
        }
      }
      else if (flag == 'pres') {
        if (det !== -1) {
          this.addedPrescription.splice(det, 1);
          this.resetPres();
        }
      }

    }
  }

  get currentVisitPrescriptions(): any {
    return this.addedPrescription?.filter(x => x?.visitId == this.visitId) || [];
  }

  addQuickPrescription(p) {
    const current = this.currentVisitPrescriptions;
    const toAdd = (p?.values || [])
      .filter(f => !current.some(c => c?.medicineId == f?.medicineId))
      .map(f => {
        const { id, name, physicianId, ...row } = f;
        return { ...row, visitId: this.visitId, createdDate: null };
      });
    if (!toAdd.length) {
      this.toaster.ForDanger('Already Added For this Visit');
      return;
    }
    this.addedPrescription = [...toAdd, ...(this.addedPrescription || [])];
    this.addedPrescription.sort((a, b) => b?.visitId - a?.visitId);
  }

  get presTableRows(): any {
    return this.fromPage == 'video-consultation' ? this.currentVisitPrescriptions : (this.addedPrescription || []);
  }

  selectedFavorite: any = null;
  favoriteMedicineOptions: Array<any> = [];

  onFavoritePrescriptionClick(p) {
    if (this.fromPage != 'video-consultation') {
      this.addQuickPrescription(p);
      return;
    }
    if (this.selectedFavorite?.name == p?.name) {
      this.closeFavoriteOptions();
      return;
    }
    const current = this.currentVisitPrescriptions;
    this.selectedFavorite = p;
    this.favoriteMedicineOptions = (p?.values || []).map(f => {
      const alreadyAdded = current.some(c => c?.medicineId == f?.medicineId);
      return { ...f, alreadyAdded, checked: !alreadyAdded };
    });
  }

  removeFavoriteOption(i: number) {
    this.favoriteMedicineOptions.splice(i, 1);
  }

  closeFavoriteOptions() {
    this.selectedFavorite = null;
    this.favoriteMedicineOptions = [];
  }

  addSelectedFavoriteMedicines() {
    const selected = this.favoriteMedicineOptions
      .filter(m => m.checked && !m.alreadyAdded)
      .map(({ alreadyAdded, checked, ...f }) => f);
    if (!selected.length) {
      this.toaster.ForDanger('Please select a medicine to add');
      return;
    }
    this.addQuickPrescription({ values: selected });
    this.closeFavoriteOptions();
  }

  utcToLocalConversionDateAndTime(date) {
    if (date != null && date != "" && date != undefined) {
      return this.datService.dateUtctoLocalDateAndTime(date);
    }
  }

  getQtyAndDays(data: any): string {

    let qty = "";
    let days = "";
    let returnString = "";
    if (data.qty == 1) {
      qty += "1 no";
    } else if (data.qty > 1) {
      qty += data.qty;
      qty += " nos";
    }

    if (data.days == 1) {
      days += "1 day";
    }
    else if (data.days > 1) {
      days += data.days;
      days += " days";
    }
    returnString += qty;
    if (days != "") {
      // returnString += ", ";
      returnString += days;
    }
    return returnString;
  }

  NotesTypevalueChanges(value) {
    if (value != null && value != '') {
      this.phcharflag = true;
      this.phlen = 4000 - value.length;
    }
  }

  editTable(flag, det, i) {
    if (flag == 'comp') {
      this.showComplaintForm = true;
      this.duplicateExistsComplain = false;
      this.isSubmittedCom = false;
      this.compEdit = true;
      this.compEditIndex = i;
      this.compEditData = det;
      this.patientcomplaintEditForm.patchValue(det);
    }
    else if (flag == 'currMed') {
      this.showCurrentMedicationForm = true;
      this.duplicateCurrMed = false;
      this.isSubmittedCurrMed = false;
      this.currMedEdit = true;
      this.currMedEditIndex = i;
      this.currMedEditData = det;
      this.patientmedicationEditForm.patchValue(det);
    }
    else if (flag == 'medHis') {
      this.showMedicalHistoryForm = true;
      this.duplicateMedicalHistory = false;
      this.isSubmittedMedHis = false;
      this.medHisEdit = true;
      this.medHistoryEditIndex = i;
      this.medHistoryEditData = det;
      this.patientmedicalHistoryForm.patchValue(det);
    }
    else if (flag == 'familyHistory') {
      this.showFamilyForm = true;
      this.duplicateFamHis = false;
      this.isSubmittedFam = false;
      this.familyHisEdit = true;
      this.familyHistoryEditIndex = i;
      this.familyHistoryEditData = det;
      this.FamilyHisForm.patchValue(det);
    }
    else if (flag == 'socialHabits') {
      this.showSocialHabitsForm = true;
      this.duplicateSocialHabit = false;
      this.isSubmittedSocial = false;
      this.socialHabitEdit = true;
      this.socialEditIndex = i;
      this.socialHabitEditData = det;
      this.patientSocialHabitsEditForm.patchValue(det);
    }
    else if (flag == 'allergy') {
      this.showAllergyForm = true;
      this.duplicateAllergy = false;
      this.isSubmittedAllergy = false;
      this.allergyEdit = true;
      this.allergyEditIndex = i;
      this.allergyEditData = det;
      this.patientAllergyEditForm.patchValue(det);
    }
    else if (flag == 'follow') {
      this.showFollowupForm = true;
      this.isFollowUpSubmitted = false;
      this.FollowEdit = true;
      this.FollowEditIndex = i;
      const x = !!det?.inputJson ? det?.inputJson : det;
      const doc = !!det?.inputJson ? det?.inputJson?.Doctor : det?.doctor;
      const date = !!det?.inputJson ? det?.inputJson?.DateTime : det?.date;
      this.followUpForm.patchValue(x);
      this.followUpForm.controls['doctor'].setValue(doc);
      this.followUpForm.controls['date'].setValue(date);
    }
    else if (flag == 'diag') {
      this.showDiagnosisForm = true;
      this.isSubmittedDiag = false;
      this.duplicateDiag = false;
      this.diagEdit = true;
      this.diaEditIndex = i;
      this.diagEditData = det;
      this.diagnosisForm.patchValue(det);
      this.diagnosisForm.controls['diagnosisId'].setValue(det.diagnosisId);
      this.diagnosisForm.controls['updatedDiagnosisId'].setValue(det?.updatedDiagnosisId);
      if (det.diagnosis?.name) {
        this.diagnosisForm.controls['diagnosisName'].setValue(det?.diagnosis?.name);
      } else {
        this.diagnosisForm.controls['diagnosisName'].setValue(det?.diagnosisName);
      }
    }
    else if (flag == 'Inves') {
      this.showInvestigationForm = true;
      this.isSubmittedInves = false;
      this.duplicateInves = false;
      this.invesEdit = true;
      this.invesEditIndex = i;
      this.invesEditData = det;
      this.serviceMstId = det.serviceId;
      this.loadPatientInvestigations();
      this.investigationform.patchValue(det);
      this.serviceMstId = null;
      this.investigationform.controls['serviceName'].setValue((det?.services?.name || det?.serviceName));
    }
    else if (flag == 'pres') {
      this.showPrescriptionForm = true;
      this.isSubmittedPres = false;
      this.presEdit = true;
      this.duplicatePres = false;
      this.presEditData = det;
      this.presEditIndex = i;
      // this.prescriptionForm.patchValue(det);
      this.prescriptionForm.controls['medicineId'].setValue(det?.medicineId);
      this.prescriptionForm.controls['dosage'].setValue(det.dosage);
      this.prescriptionForm.controls['dosageunit'].setValue(det.dosageunit);
      this.prescriptionForm.controls['createdDate'].setValue(det.createdDate);
      var durationunit;
      if (det.durationUnit == "Days") {
        durationunit = 'd';
      }
      else if (det.durationUnit == "Month") {
        durationunit = 'm';
      }
      else if (det.durationUnit == "Week") {
        durationunit = 'w';
      }
      this.prescriptionForm.controls['duration'].setValue(det.duration != 0 ? det.duration + durationunit : det.durationUnit);
      this.prescriptionForm.controls['durationcount'].setValue(det.duration);
      this.prescriptionForm.controls['durationunit'].setValue(det.durationUnit);
      this.prescriptionForm.controls['instructions'].setValue(det.instructions);
      this.prescriptionForm.controls['mor'].setValue(det.mor);
      this.prescriptionForm.controls['aft'].setValue(det.aft);
      this.prescriptionForm.controls['night'].setValue(det.night);
      this.prescriptionForm.controls['eve'].setValue(det.eve);
      this.prescriptionForm.controls['frequency'].setValue(det.frequency);
      this.prescriptionForm.controls['qty'].setValue(det.qty);
      this.prescriptionForm.controls['takenAt'].setValue(det.takenAt);
      this.sclDosage[0] = det.mor != '0' ? true : false;
      this.sclDosage[1] = det.aft != '0' ? true : false;
      this.sclDosage[2] = det.eve != '0' ? true : false;
      this.sclDosage[3] = det.night != '0' ? true : false;
      if (det.frequency == 'STAT' || det.frequency == 'SOS' || det.frequency == 'Once a Month' || det.frequency == 'Every Week' || det.frequency == 'Every Alternate Day') {
        this.sclDosage[0] = false;
        this.sclDosage[1] = false;
        this.sclDosage[2] = false;
        this.sclDosage[3] = false;
      }
    }
  }

  copy(event, flag, dets) {
    event.target.disabled = true;
    var det = { ...dets };
    if (!!det) {
      det.visitId = this.visitId;
      if (flag == 'comp') {
        if (this.addedComplaints?.filter(x => x?.visitId == this.visitId).some(e => e?.chiefComplaintId == det?.chiefComplaintId)) {
          this.toaster.ForDanger('Already Copied For this Visit')
          return;
        }
        det.createdDate = null;
        this.addedComplaints.unshift(det)
        this.addedComplaints?.sort((a, b) => b?.visitId - a?.visitId);
        event.target.disabled = false;
      }
      else if (flag == 'currMed') {
        if (this.addedCurrentMedications?.filter(x => x?.visitId == this.visitId).some(e => e?.mud == det?.medicineId)) {
          this.toaster.ForDanger('Already Copied For this Visit')
          return;
        }
        det.createdDate = null;
        this.addedCurrentMedications.unshift(det)
        this.addedCurrentMedications?.sort((a, b) => b?.visitId - a?.visitId);
        event.target.disabled = false;
      }
      else if (flag == 'medHis') {
        if (this.addedMedicalHistories?.filter(x => x?.visitId == this.visitId).some(e => e?.medicalHistoryId == det?.medicalHistoryId)) {
          this.toaster.ForDanger('Already Copied For this Visit')
          return;
        }
        det.createdDate = null;
        this.addedMedicalHistories.unshift(det)
        this.addedMedicalHistories?.sort((a, b) => b?.visitId - a?.visitId);
        event.target.disabled = false;
      }
      else if (flag == 'familyHistory') {
        if (this.addedFamilyHistories?.filter(x => x?.visitId == this.visitId).some(e => e?.medicalHistoryId == det?.medicalHistoryId)) {
          this.toaster.ForDanger('Already Copied For this Visit')
          return;
        }
        det.createdDate = null;
        this.addedFamilyHistories.unshift(det)
        this.addedFamilyHistories?.sort((a, b) => b?.visitId - a?.visitId);
        event.target.disabled = false;
      }
      else if (flag == 'socialHabits') {
        if (this.addedSocialHabits?.filter(x => x?.visitId == this.visitId).some(e => e?.socialHabitsId == det?.socialHabitsId)) {
          this.toaster.ForDanger('Already Copied For this Visit')
          return;
        }
        det.createdDate = null;
        this.addedSocialHabits.unshift(det)
        this.addedSocialHabits?.sort((a, b) => b?.visitId - a?.visitId);
        event.target.disabled = false;
      }
      else if (flag == 'allergy') {
        if (this.addedAllergies?.filter(x => x?.visitId == this.visitId).some(e => e?.allergyId == det?.allergyId)) {
          this.toaster.ForDanger('Already Copied For this Visit')
          return;
        }
        det.createdDate = null;
        this.addedAllergies.unshift(det)
        this.addedAllergies?.sort((a, b) => b?.visitId - a?.visitId);
        event.target.disabled = false;
      }
      else if (flag == 'follow') {
        det.createdDate = null;
        this.addedfollowUp.unshift(det)
        this.addedfollowUp?.sort((a, b) => b?.visitId - a?.visitId); event.target.disabled = false;
      }
      else if (flag == 'diag') {
        if (this.addedDiagnosis?.filter(x => x?.visitId == this.visitId).some(e => (e?.diagnosisId == det?.diagnosisId))) {
          this.toaster.ForDanger('Already Copied For this Visit')
          return;
        }
        det.createdDate = null;
        this.addedDiagnosis.unshift(det); event.target.disabled = false;
        this.addedDiagnosis?.sort((a, b) => b?.visitId - a?.visitId);
      }
      else if (flag == 'Inves') {
        if (this.addedInves?.filter(x => x?.visitId == this.visitId).some(e => (e?.serviceId == det?.serviceId))) {
          this.toaster.ForDanger('Already Copied For this Visit')
          return;
        }
        det.createdDate = null;
        this.addedInves.unshift(det); event.target.disabled = false;
        this.addedInves?.sort((a, b) => b?.visitId - a?.visitId);
      }
      else if (flag == 'pres') {
        if (this.addedPrescription?.filter(x => x?.visitId == this.visitId).some(e => (e?.medicineId == det?.medicineId))) {
          this.toaster.ForDanger('Already Copied For this Visit')
          return;
        }
        det.createdDate = null;
        this.addedPrescription.unshift(det); event.target.disabled = false;
        this.addedPrescription?.sort((a, b) => b?.visitId - a?.visitId);
      }
    }
  }

  loadPatientInvestigations(): void {

    if(!this.docId || !this.visitId || !this.serviceMstId){
      return;
    }
    this.patientinvestigationSrvc.list(`investigation/${this.tenandId}/${this.branchId}/${this.regId}/${this.visitId}/GetPaitentInvestigationDatasWithMaster/${this.docId}?tenantId=${this.tenandId}&isLoadMaster=true&isLoadPatientData=false&skip=${this.skip}&take=${this.take}&name=${this.name}&serviceMstId=${this.serviceMstId}`)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((datum: any) => {
        const newList = datum.masterData
          .map(x => ({
            ...x,
            concatName: x?.serviceType
              ? `${x?.name} - ${x?.serviceType}`
              : `${x?.name} - ${x?.serviceCategory?.name}`
          }))
          .filter(ele => ele.isActive === 'Y');

        if (this.skip === 0 && !this.invesEdit) {
          this.InvestigationList = newList;
        } else {
          this.InvestigationList = [...this.InvestigationList, ...newList];
        }
      }
      )

  }

  addFromPopup(flag, event) {
    if (flag == 'complaint') {
      this.patientcomplaintEditForm?.get('chiefComplaintId')?.setValue(this.currentPopupItem?.id);
      this.addTable(flag, event, true);
    }
    else if (flag == 'diag') {
      this.diagnosisForm?.get('diagnosisId')?.setValue(this.currentPopupItem?.id);
      this.diagnosisForm?.get('diagnosisName')?.setValue(this.currentPopupItem?.name);
      this.diagnosisForm?.get('updatedDiagnosisId')?.setValue(this.patientDiagnosisList?.find(e => e?.id == this.currentPopupItem?.id)?.updatedId);
      this.addTable(flag, event, true);
    }
    else if (flag == 'inves') {
      this.investigationform?.get('serviceId')?.setValue(this.currentPopupItem?.id);
      this.investigationform?.get('serviceName')?.setValue(this.currentPopupItem?.name);
      this.addTable(flag, event, true);
    }

  }

  addTable(flag, event, isPopup?) {
    event.target.disabled = true;
    if (flag == 'complaint') {

      this.isSubmittedCom = true;
      if (this.patientcomplaintEditForm?.valid && !this.duplicateExistsComplain) {
        const detail = this.patientcomplaintEditForm?.getRawValue();
        detail.visitId = this.visitId;
        if (this.compEdit) {
          this.addedComplaints[this.compEditIndex] = detail;
          this.compEditIndex = null; this.compEdit = false;
        } else { this.addedComplaints.unshift(detail); }
        this.patientcomplaintEditForm.reset(); event.target.disabled = false; this.isSubmittedCom = false;
        this.isSubmittedCom = false;
        if (isPopup) { this.showComplaintPopup = false; this.currentPopupItem = null; }
      } else { event.target.disabled = false; this.toaster.ForDanger('Please Check the Fields'); }
      this.addedComplaints?.sort((a, b) => b?.visitId - a?.visitId);
    }
    else if (flag == 'medHis') {
      this.isSubmittedMedHis = true;
      if (this.patientmedicalHistoryForm?.valid && !this.duplicateMedicalHistory && !this.DateExceeds) {
        const detail = this.patientmedicalHistoryForm?.getRawValue(); detail.visitId = this.visitId;
        if (this.medHisEdit) {
          this.addedMedicalHistories[this.medHistoryEditIndex] = detail;
          this.medHistoryEditIndex = null; this.medHisEdit = false;
        }
        else { this.addedMedicalHistories.unshift(detail); }
        this.patientmedicalHistoryForm.reset();
        this.patientmedicalHistoryForm?.get('historyType')?.setValue(10);
        event.target.disabled = false; this.isSubmittedMedHis = false;
      }
      else { event.target.disabled = false; this.toaster.ForDanger('Please Check the Fields'); }
      this.addedMedicalHistories?.sort((a, b) => b?.visitId - a?.visitId);
    }
    else if (flag == 'family') {
      this.isSubmittedFam = true;
      if (this.FamilyHisForm?.valid && !this.duplicateFamHis) {
        const detail = this.FamilyHisForm?.getRawValue(); detail.visitId = this.visitId;
        if (this.familyHisEdit) {
          this.addedFamilyHistories[this.familyHistoryEditIndex] = detail;
          this.familyHistoryEditIndex = null; this.familyHisEdit = false;
        } else { this.addedFamilyHistories.unshift(detail); }
        this.FamilyHisForm.reset(); event.target.disabled = false; this.isSubmittedFam = false;
      } else { event.target.disabled = false; this.toaster.ForDanger('Please Check the Fields'); }
      this.addedFamilyHistories?.sort((a, b) => b?.visitId - a?.visitId);
    }
    else if (flag == 'currMed') {
      this.isSubmittedCurrMed = true;
      if (this.patientmedicationEditForm?.valid && !this.duplicateCurrMed) {
        const detail = this.patientmedicationEditForm?.getRawValue(); detail.visitId = this.visitId;
        if (this.currMedEdit) {
          this.addedCurrentMedications[this.currMedEditIndex] = detail;
          this.currMedEditIndex = null; this.currMedEdit = false;
        } else { this.addedCurrentMedications.unshift(detail); }
        this.patientmedicationEditForm.reset(); event.target.disabled = false; this.isSubmittedCurrMed = false;
        event.target.disabled = false; this.isSubmittedCurrMed = false;

      }
      else {
        event.target.disabled = false; this.toaster.ForDanger('Please Check the Fields');
        this.addedCurrentMedications?.sort((a, b) => b?.visitId - a?.visitId);
      }
    }
    else if (flag == 'socialHabit') {
      this.isSubmittedSocial = true;
      if (this.patientSocialHabitsEditForm?.valid && !this.duplicateSocialHabit) {
        const detail = this.patientSocialHabitsEditForm?.getRawValue(); detail.visitId = this.visitId;
        if (this.socialHabitEdit) {
          this.addedSocialHabits[this.socialEditIndex] = detail;
          this.socialEditIndex = null; this.socialHabitEdit = false;
        } else { this.addedSocialHabits.unshift(detail); }
        this.patientSocialHabitsEditForm.reset(); event.target.disabled = false; this.isSubmittedSocial = false;
        event.target.disabled = false; this.isSubmittedSocial = false;

      }
      else {
        event.target.disabled = false; this.toaster.ForDanger('Please Check the Fields');
        this.addedSocialHabits?.sort((a, b) => b?.visitId - a?.visitId);
      }
    }
    else if (flag == 'allergy') {
      this.isSubmittedAllergy = true;
      if (this.patientAllergyEditForm?.valid && !this.duplicateAllergy) {
        const detail = this.patientAllergyEditForm?.getRawValue(); detail.visitId = this.visitId;

        if (this.allergyEdit) {
          this.addedAllergies[this.allergyEditIndex] = (detail);
          this.allergyEdit = false;
          this.allergyEditIndex = null;
        } else { this.addedAllergies.unshift(detail); }
        this.patientAllergyEditForm.reset(); this.patientAllergyEditForm.get('isActive')?.setValue(true);
        event.target.disabled = false; this.isSubmittedAllergy = false;
      } else { event.target.disabled = false; this.toaster.ForDanger('Please Fill Required Fields'); }
      this.addedAllergies?.sort((a, b) => b?.visitId - a?.visitId);
    }
    else if (flag == 'vitals') {
      this.isSubmittedVitals = true;
      if (this.vitalForms.valid) {
        const { takenDatetime, ...rest } = this.vitalForms.value;
        const hasAnyValue = Object.values(rest).some(value => {
          if (Array.isArray(value)) {
            return value.some(v => v === true || (typeof v === 'string' && v.trim()));
          }
          return value?.toString().trim();
        });
        if (this.vitalForms.untouched || !hasAnyValue) {
          this.toaster.ForDanger("kindly fill any one of the field");
          event.target.disabled = false;
          return;
        }
        const detail = this.vitalForms.getRawValue();
        detail.visitId = this.visitId;
        this.vitalsData = detail;
        this.editVitals = true;
        event.target.disabled = false;
        this.isSubmittedVitals = false;
        this.showVitalsForm = false;
      }
      else {
        event.target.disabled = false;
        this.toaster.ForDanger('Please Check the Fields');
      }
    }
    // else if (flag == 'bloodGroup') {
    //   this.isSubmittedBloodGroup = true;
    //   if (this.bloodgroupForm?.valid) {
    //     const detail = this.bloodgroupForm.getRawValue();
    //     detail.visitId = this.visitId;
    //     this.bloodGroupId = detail?.bloodGroupId;
    //     this.editBlood = true;
    //     event.target.disabled = false;
    //     this.isSubmittedBloodGroup = false;
    //   }
    //   else {
    //     event.target.disabled = false;
    //     this.toaster.ForDanger('Please Check the Fields');
    //   }
    // }
    else if (flag == 'diag') {
      this.isSubmittedDiag = true;
      if (this.diagnosisForm?.valid && !this.duplicateDiag) {
        const detail = this.diagnosisForm?.getRawValue(); detail.visitId = this.visitId;
        if (this.diagEdit) {
          this.addedDiagnosis[this.diaEditIndex] = (detail);
          this.diagEdit = false;
          this.diaEditIndex = null;
        } else { this.addedDiagnosis.push(detail); }
        this.diagnosisForm.reset();
        event.target.disabled = false; this.isSubmittedDiag = false;
        if (isPopup) { this.showDiagnosisPopup = false; this.currentPopupItem = null; }
      } else { event.target.disabled = false; this.toaster.ForDanger('Please Check Fields'); }
      this.addedDiagnosis?.sort((a, b) => b?.visitId - a?.visitId);
    }
    else if (flag == 'inves') {
      this.isSubmittedInves = true;
      if (this.investigationform?.valid && !this.duplicateInves) {
        const detail = this.investigationform?.getRawValue(); detail.visitId = this.visitId;
        if (this.invesEdit) {
          this.addedInves[this.invesEditIndex] = (detail);
          this.invesEdit = false;
          this.invesEditIndex = null;
        } else { this.addedInves.push(detail); }
        this.investigationform.reset();
        event.target.disabled = false; this.isSubmittedInves = false;
        if (isPopup) { this.showInvestigationPopup = false; this.currentPopupItem = null; }
      } else { event.target.disabled = false; this.toaster.ForDanger('Please Check Fields'); }
      this.addedInves?.sort((a, b) => b?.visitId - a?.visitId);

    }
    else if (flag == 'pres') {
      this.isSubmittedPres = true;
      if (this.prescriptionForm?.valid && !this.duplicatePres) {
        const detail = this.prescriptionForm?.getRawValue(); detail.visitId = this.visitId;
        if (this.presEdit) {
          this.addedPrescription[this.presEditIndex] = (detail);
          this.presEdit = false;
          this.presEditIndex = null;
        } else { this.addedPrescription.push(detail); }
        // this.prescriptionForm.reset();
        this.resetPres();
        event.target.disabled = false; this.isSubmittedPres = false;
      } else { event.target.disabled = false; this.toaster.ForDanger('Please Check Fields'); }
      this.addedPrescription?.sort((a, b) => b?.visitId - a?.visitId);

    }
    else if (flag == 'follow') {
      this.isFollowUpSubmitted = true;
      if (this.followUpForm?.valid) {
        const detail = this.followUpForm?.getRawValue(); detail.visitId = this.visitId;
        const detss = this.performDocList?.find(e => e?.id == detail.doctor)
        detail.docName = `${detss?.doctor}${detss?.displayName}`;
        if (this.FollowEdit) {
          this.addedfollowUp[this.FollowEditIndex] = (detail);
          this.FollowEdit = false;
          this.FollowEditIndex = null;
        } else { this.addedfollowUp.unshift(detail); }

        this.followUpForm.reset();
        event.target.disabled = false; this.isFollowUpSubmitted = false;
      } else { event.target.disabled = false; this.toaster.ForDanger('Please Check the Fields'); }
      this.addedfollowUp?.sort((a, b) => b?.visitId - a?.visitId);
    }
  }

  resetComp() {
    this.patientcomplaintEditForm?.reset();
    this.duplicateExistsComplain = false;
    this.isSubmittedCom = false;
    this.compEditIndex = null;
    this.compEdit = false;
    this.compEditData = {};
  }

  resetMedHis() {
    this.patientmedicalHistoryForm?.reset();
    this.duplicateMedicalHistory
    this.isSubmittedMedHis = false;
    this.medHistoryEditIndex = null;
    this.medHisEdit = false;
    this.medHistoryEditData = {};
    this.patientmedicalHistoryForm?.get('historyType')?.setValue(10);
  }

  resetFamilyHist() {
    this.FamilyHisForm?.reset();
    this.duplicateFamHis = false;
    this.isSubmittedFam = false;
    this.familyHistoryEditIndex = null;
    this.familyHisEdit = false;
    this.familyHistoryEditData = {};
  }

  resetCurrMed() {
    this.patientmedicationEditForm?.reset();
    this.duplicateCurrMed = false;
    this.isSubmittedCurrMed = false;
    this.currMedEditIndex = null;
    this.currMedEdit = false;
    this.currMedEditData = {};
  }

  resetSocialHabits() {
    this.patientSocialHabitsEditForm?.reset();
    this.duplicateSocialHabit = false;
    this.isSubmittedSocial = false;
    this.socialEditIndex = null;
    this.socialHabitEdit = false;
    this.socialHabitEditData = {};
  }

  resetAllergy() {
    this.patientAllergyEditForm?.reset();
    this.duplicateAllergy = false;
    this.isSubmittedAllergy = false;
    this.allergyEditIndex = null;
    this.allergyEdit = false;
    this.allergyEditData = {};
  }

  resetVitals() {
    this.vitalForms?.reset();
    this.vitalForms?.get('takenDatetime')?.setValue(new Date());
    this.isSubmittedVitals = false;
  }

  resetFollow() {
    this.isFollowUpSubmitted = false;
    this.followUpForm?.reset();
    this.FollowEdit = false;
    this.FollowEditIndex = null;
  }

  resetDiag() {
    this.isSubmittedDiag = false;
    this.diagnosisForm?.reset();
    this.diagEdit = false;
    this.diaEditIndex = null;
    this.duplicateDiag = false;
    this.diagEditData = {};
  }

  resetInves() {
    this.isSubmittedInves = false;
    this.investigationform?.reset();
    this.invesEdit = false;
    this.invesEditIndex = null;
    this.duplicateInves = false;
    this.invesEditData = {};
  }

  resetPres() {
    this.isSubmittedPres = false;
    this.prescriptionForm?.reset();
    this.presEdit = false;
    this.presEditIndex = null;
    this.duplicatePres = false;
    this.presEditData = {};
    this.sclDosage= [false, false, false, false];
  }

  patientDiagnosisList: Array<any> = [];
  patientDiagnosisQuickSelectList: Array<any> = [];
  tempList: Array<any> = [];

  DiagnosisMasterList() {

    this.patientDiagnosisData.list(`diagnosis/${this.tenandId}/${this.branchId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.patientDiagnosisList = data;
      this.LoadPatientDiagnosis();
    }, (error) => {
    }, () => {
    });
  }

  LoadPatientDiagnosis(): void {
    // this.searchCtrl.setValue("");
    this.isSubmittedCom = false;
    this.patientDiagnosisData.list(`${this.tenandId}/${this.branchId}/${this.regId}/${this.visitId}/${this.docId}/patientDiagnosis`)
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

        this.patientDiagnosisQuickSelectList = data.quickSelect;
        this.tempList = data.diagnosis;

      }, (error) => {
      }, () => {

      });
  }

  medicalHist() {
    if (this.medicalHistoryMasterList?.length > 0) return;
    this.rolesService.list("medicalhistory/" + this.tenandId + '/' + this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((datasocialHabitsAll: any) => {
      this.medicalHistoryMasterList = datasocialHabitsAll.value;
      this.MedicalHistoryAllList = datasocialHabitsAll.value;
      this.AllMedicalHistoryBackup = datasocialHabitsAll.value;
    })
  }

  completeConsultation(event) {
    event.target.disabled = true;

    if (this.addedSocialHabits?.filter(x => x?.visitId == this.visitId)?.length == 0 && this.addedCurrentMedications?.filter(x => x?.visitId == this.visitId)?.length == 0 && this.addedMedicalHistories?.filter(x => x?.visitId == this.visitId)?.length == 0 && this.addedFamilyHistories?.filter(x => x?.visitId == this.visitId)?.length == 0 && this.addedAllergies?.filter(x => x?.visitId == this.visitId)?.length == 0 && this.addedComplaints?.filter(x => x?.visitId == this.visitId)?.length == 0 && this.addedInves?.filter(x => x?.visitid == this.visitId)?.length == 0 && this.addedPrescription?.filter(x => x?.visitId == this.visitId)?.length == 0 && this.addedfollowUp?.filter(x => x?.visitId == this.visitId)?.length == 0 && this.addedDiagnosis?.filter(x => x?.visitId == this.visitId)?.length == 0 && !this.editVitals) { this.toaster.ForDanger('Please Fill Any Section'); event.target.disabled = false; return; }

    const patientvitalsData = this.vitalsData;
    if (!!patientvitalsData) {
      patientvitalsData.createdBy = parseInt(this.userId),
        patientvitalsData.createdDate = new Date(),
        patientvitalsData.tenantId = this.tenandId,
        patientvitalsData.branchId = this.branchId,
        patientvitalsData.regId = this.regId,
        patientvitalsData.performingDoctor = this.docId
    }

//     const bloodGroupData = this.bloodGroupId ? {
//     regId: this.regId,
//     bloodGroupId: this.bloodGroupId,
//     tenantId: this.tenandId,
//     branchId: this.branchId,
//     createdDate: new Date(),
//     createdIP: null,
//     createdBy: this.docId,
//     updatedDate: null,
//     updatedIP: null,
//     updatedBy: null
// } : null;

    const allergy = this.addedAllergies?.filter(x => x?.visitId == this.visitId)?.map(e => {
      return {
        allergyId: e?.allergyId,
        duration: e?.duration,
        period: e?.period,
        notes: e?.notes,
        tenantId: this.tenandId,
        branchId: this.branchId,
        regId: this.regId,
        isActive: 'IsActive',//== true ? 'IsActive' : 'InActive',
        verificationStatus: e?.verificationStatus || null,
        severity: e?.severity || null,
        updatedBy: null,
        updatedDate: null,
        updatedIP: null,
        createdBy: parseInt(localStorage.getItem("userId")),
        createdDate: new Date(),
        createdIP: null,
        visitId: this.visitId,
      }
    });

    const compDetail = this.addedComplaints?.filter(x => x?.visitId == this.visitId)?.map(e => {
      return {
        regId: this.regId,
        visitId: this.visitId,
        chiefComplaintId: e.chiefComplaintId,
        duration: e?.duration,
        period: e?.period,
        presentHistory: e.presentHistory,
        pastHistory: null,
        tenantId: this.tenandId,
        branchId: this.branchId,
        createdDate: new Date(),
        createdBy: parseInt(this.userId),
        createdIP: null,
        updatedBy: null,
        updatedDate: null,
        updatedIP: null,
        performingDoctor: this.docId
      }
    })

    const invest = this.addedInves?.filter(x => x.visitId == this.visitId)?.map(e => {
      return {
        regid: this.regId,
        visitId: this.visitId,
        testresult: null,
        notes: null,
        tenantId: this.tenandId,
        branchId: this.branchId,
        serviceId: e.serviceId,
        physicianId: this.docId,
        updatedBy: null,
        updatedDate: null,
        updatedIP: null,
        createdBy: parseInt(this.userId),
        createdDate: new Date(),
        createdIP: null,
        isDiscount: false,
        discountType: null,
        discountAmount: null,
        discountPercentage: null,
        amount: null,
        netAmount: null,
        isOutsideLab: false,
        LabSentStatus: 'N',
        RadSentStatus: 'N',
        performingDoctor: this.docId
      }
    })

    const diag = this.addedDiagnosis?.filter(x => x?.visitId == this.visitId)?.map(e => {
      return {
        diagnosisId: e.diagnosisId,
        treatmentGiven: e.treatmentGiven,
        risk: null,
        docIdForQC: this.docId,
        NameForQC: null,
        tenantId: this.tenandId,
        branchId: this.branchId,
        regId: this.regId,
        visitId: this.visitId,
        visitedDate: null,
        admissionId: null,
        physicianId: this.docId,
        justVisit: '',
        updatedBy: null,
        updatedDate: new Date(),
        updatedIP: null,
        createdBy: parseInt(this.userId),
        createdDate: new Date(),
        createdIP: null,
        updatedDiagnosisId: e.updatedDiagnosisId,
        onSet: null,
        performingDoctor: this.docId,
        performingNurse: null
      }
    })

    const pres = this.addedPrescription?.filter(x => x?.visitId == this.visitId)?.map(e => {
      return {
        regId: this.regId,
        visitId: this.visitId,
        medicineId: e.medicineId,
        days: e.days,
        mor: e.mor,
        aft: e.aft,
        eve: e.eve,
        night: e.night,
        frequency: e.frequency,
        qty: e.qty,
        takenAt: e.takenAt,
        instructions: e.instructions,
        dosage: e.dosage,
        dosageunit: e.dosageunit,
        advice: e.advice,
        duration: e.durationcount || e. duration,
        durationUnit: e.durationunit || e.durationUnit,
        docIdForQC: this.docId,
        presNameForQC: !!e?.presNameForQC ? e?.presNameForQC : ((e?.medicine?.name) + ' / ' + (e?.medicine?.genericName?.name)),
        tenantId: this.tenandId,
        branchId: this.branchId,
        updatedBy: null,
        updatedDate: null,
        updatedIP: null,
        createdBy: parseInt(this.userId),
        createdDate: null,
        createdIP: null,
        pharmacyStatus: 'N',
        totalDiscounttype: 0,
        totalDiscountPer: 0,
        totalDiscountAmt: 0,
        lineItemDiscounttype: 0,
        lineItemDiscountPer: 0,
        lineItemDiscountAmt: 0,
        drugIntakeRoute: null,
        drugUsageArea: null,
        drugIntakeAdvice: null,
        drugIntakeMode: null,
        routeMethod: null,
        sortOrderId: null,
        performingDoctor: this.docId,
        performingNurse: null
      }
    })

    const follow = this.addedfollowUp?.filter(x => x?.visitId == this.visitId)?.map(e => {
      const docData = this.performDocList?.find(x => x?.id == e?.doctor);
      const visitDoc = this.performDocList?.find(x => x?.id == this.docId);
      if (!e?.inputJson) {
        e = {
          "Reason": e?.Observation,
          "Type": "Inhouse",
          "Mode": false,
          "Doctor": e?.doctor,
          "Appointmentperiod": "1",
          "Scheduled": "New",
          "DateTime": e?.date,
          "oldApp": this.visitLog[0]?.appointmentId,
          "refDoc": visitDoc?.displayName,
          "refDep": visitDoc?.department?.name,
          "docName": `${docData?.doctor}${docData?.displayName}`,
          "docid": e?.doctor,
          "depid": docData?.departmentId,
          "deptName": docData?.department?.name,
          "Observation": e?.Observation,
          "treatment": e?.treatment
        }
      }
      return {
        "woId": null,
        "regId": this.regId,
        "ipId": null,
        "careTaskType": 14,
        "careTaskPlace": null,
        "careTaskStatus": 4,
        "CreatedDate": new Date(),
        "CreatedBy": parseInt(this.userId),
        "UpdatedDate": null,
        "UpdatedBy": null,
        "TenantId": this.tenandId,
        "BranchId": this.branchId,
        "CreatedIP": null,
        "UpdatedIP": null,
        "inputJson": !!e?.inputJson ? JSON.stringify(e?.inputJson) : JSON.stringify(e),
        "visitId": this.visitId,
        "SubstatusName": "SecondOpinion-RefAppointment",
        "doctorId": e?.Doctor,
        "performingDoctor": this.docId
      }
    })

    const Family = this.addedFamilyHistories?.filter(x => x?.visitId == this.visitId)?.map(e => {
      return {
        medicalHistoryId: e?.medicalHistoryId,
        duration: e?.duration || null,
        period: e?.period || null,
        notes: e?.notes,
        tenantId: this.tenandId,
        branchId: this.branchId,
        regId: this.regId,
        relationship: e?.relationship,
        updatedBy: null,
        updatedDate: null,
        updatedIP: null,
        createdBy: parseInt(localStorage.getItem("userId")),
        createdDate: new Date(),
        createdIP: null, visitId: this.visitId,
        relationshipExtension: parseInt(e?.relationshipExtension)
      };
    });

    const medicalHistory = this.addedMedicalHistories?.filter(x => x?.visitId == this.visitId)?.map(e => {
      return {
        medicalHistoryId: (!!e?.medicalHistoryId ? e?.medicalHistoryId : e?.medicalHistoryId),
        notes: e?.notes,
        attributeDetail: String(e?.attributeDetail),
        tenantId: this.tenandId,
        branchId: this.branchId,
        regId: this.regId,
        isActive: 'IsActive',
        updatedBy: null,
        updatedDate: null,
        updatedIP: null,
        createdBy: parseInt(localStorage.getItem("userId")),
        createdDate: new Date(),
        createdIP: null,
        visitId: this.visitId,

      }
    })

    const socialHabits = this.addedSocialHabits?.filter(x => x?.visitId == this.visitId)?.map(e => {
      return {
        socialHabitsId: e?.socialHabitsId,
        duration: null,
        period: null,
        tenantId: this.tenandId,
        branchId: this.branchId,
        regId: this.regId,
        updatedBy: null,
        updatedDate: null,
        updatedIP: null,
        createdBy: parseInt(localStorage.getItem("userId")),
        createdDate: new Date(),
        createdIP: null,
        socialHabitStatus: null,
        quantity: null,
        quantityInPeriod: null,
        visitId: this.visitId,
      }
    })

    const currentMedication = this.addedCurrentMedications?.filter(x => x?.visitId == this.visitId)?.map(e => {
      return {
        regId: this.regId,
        medicineId: e?.medicineId,
        activeMedication: "Y",
        startDate: null,
        endDate: null,
        reason: e?.reason,
        tenantId: this.tenandId,
        branchId: this.branchId,
        updatedBy: null,
        updatedDate: null,
        updatedIP: null,
        createdBy: parseInt(localStorage.getItem("userId")),
        createdDate: new Date(),
        createdIP: null,
        mor: "",
        aft: "",
        eve: "",
        night: "",
        frequency: "",
        visitId: this.visitId,
      }
    })

    var payload = {
      // "patientClinicalMst":bloodGroupData,
      "patientCurrentMedications": currentMedication,
      "PatientSocialHabits": socialHabits,
      'MedicalHistory': medicalHistory,
      "PatientAllergy": allergy,
      'patientVital': patientvitalsData,
      'PatientComplaints': compDetail,
      'patientInvestigation': invest,
      'patientPrescription': pres,
      "patientDiagnosis": diag,
      'PatientRefAppoinment': follow,
      'patientFamilyMedicalHistorie': Family
    }
    this.rolesService.create(`${environment.apiUrl}/EHRCaseSheetMst/HomeopathyCasesheetSave?tenantId=${this.tenandId}&branchId=${this.branchId}&regId=${this.regId}&visitId=${this.visitId}`, payload).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if (data?.details?.patientPrescription?.length > 0) {
      this.addedPrescription = data?.details?.patientPrescription?.sort((a, b) => b?.visitId - a?.visitId);
    }
    }, (err) => {
      this.toaster.ForDanger('Please Check the added sections');
      event.target.disabled = false;
    },
      () => {
        this.toaster.ForSuccess('Saved Successfully');
        event.target.disabled = false;
        this.casesheetSaved.emit({ regId: this.regId, visitId: this.visitId });
      })
  }


  visitLog: Array<any> = [];


  loadlog() {
    if (this.visitLog?.length == 0) {
      this.rolesService.list(`appointmentstatusdetail/${this.tenandId}/${this.branchId}/${this.regId}/GetallAppointmentStatusDetails?visitId=${this.visitId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.visitLog = data.details;
      })
    }
  }

  loadPhy(): void {

    if (this.performDocList?.length == 0) {
      this.rolesService.list(`physicians/${this.tenandId}/${this.branchId}/clinicalActivePhysicians?referralType=1&isActive=` + true + `&isClinical=true`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.performDocList = data.details;

        this.performDocList?.forEach(each => {
          each.doctorNameWithTitle = each?.doctor + " " + each?.name;
        })
      }, (error) => {
      }, () => {
      });
    }
  }

  loadMedicine(): void {
    this.rolesService.list("medicine/" + this.tenandId + '/' + this.branchId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.MedicineListForCurr = data.value;
    }, (error) => {
    }, () => {

    });
  }

  fetchstockmedicineDetails() {
    if (this.MedicineList?.length > 0) { return }
    this.patientPrescriptionSrvc.list("medicine/" + this.tenandId + '/' + this.branchId + '/GetMedicineListForPrescription/' + this.userId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.MedicineList = data;
      this.MedicineList.map(x => x.name = (x.name + ' / ' + (typeof (x?.genericName) != 'object' ? (x?.genericName) : x?.genericName?.name)));
      this.MedicineList.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    }, (error) => {
    }, () => {
    });
  }

  async medicineDropDownChange(event: INgxSelectOption[]) {

    var medicineId = event?.[0]?.value;
    if (event[0]?.data?.medicineCategoryName?.toLowerCase() == 'SUSPENSION'.toLowerCase() || event[0]?.data?.medicineCategoryName?.toLowerCase() == 'DROPS'.toLowerCase() ||
      event[0]?.data?.medicineCategory?.name.toLowerCase() == 'SUSPENSION'.toLowerCase() || event[0]?.data?.medicineCategory?.name.toLowerCase() == 'DROPS'.toLowerCase()) {
      this.prescriptionForm.controls['dosage'].setValue('1');
    }

    if (event.length > 0) {
      this.setMedicineProperties(medicineId, event);
      this.selectmedicinedetails(event[0].data);
    }
    let found = this.addedPrescription?.filter(x =>
      x?.visitId == this.visitId &&
      x?.medicineId == event[0]?.data?.id
    );

    if (found?.length > 0 && this.presEdit) {
      if (found[0]?.medicineId == this.presEditData?.medicineId) {
        this.duplicatePres = false;
      } else {
        this.duplicatePres = true;
      }
    }
    else if (found?.length > 0) {
      this.duplicatePres = true;
    }
    else {
      this.duplicatePres = false;
    }
  }

  setMedicineProperties(medicineId, event) {

    this.physicianMedicinePropertiesCount++;
    if (this.physicianMedicinePropertiesCount == 1) {
      this.patientPrescriptionSrvc.list("physicianmed/" + this.tenandId + '/' + this.docId + '/GetMedicineProperties').pipe(takeUntil(this.unsubscribe$)).subscribe(async (data: any) => {

        if (data?.message != "No records found") {
          this.physicianMedicineProperties = data;
        }
      }, (error) => {
        this.checkdata = true;
      }, () => {
        this.checkdata = true;
      });
    } else {
      if (this.physicianMedicineProperties?.length > 0) {
        let individualMedicine = this.physicianMedicineProperties.filter(e => e.medicineId == medicineId);


        if (individualMedicine?.length == 0) {

          this.prescriptionForm.controls['takenAt'].reset();

          this.prescriptionForm.controls['duration'].reset();;
          this.prescriptionForm.controls['mor'].reset();
          this.prescriptionForm.controls['aft'].reset();
          this.prescriptionForm.controls['night'].reset();
          this.prescriptionForm.controls['eve'].reset();
          this.prescriptionForm.controls['frequency'].reset();
          this.prescriptionForm.controls['dosageunit'].setValue('nos');
          this.prescriptionForm.controls['dosage'].setValue('1');
        } else {
          this.prescriptionForm.controls['dosage'].setValue(individualMedicine[0].dosage);
          this.prescriptionForm.controls['dosageunit'].setValue(individualMedicine[0].dosageunit);

          if (individualMedicine[0].frequency != "Once" && individualMedicine[0].frequency != "Twice" && individualMedicine[0].frequency != "Thrice" && individualMedicine[0].frequency != "4 Times") {
            // this.showadvancedtiming=true;
            this.prescriptionForm.controls['timing'].setValue(individualMedicine[0].frequency);
          }
          else {
            this.showadvancedtiming = false;
            if (parseInt(individualMedicine[0].eve) == 0) {
              this.frequency = individualMedicine[0].mor + "-" + individualMedicine[0].aft + "-" + individualMedicine[0].night;

              var timing = this.onceData.find(x => x.name == this.frequency)



              this.prescriptionForm.controls['frequency'].setValue(this.frequency);
            }
            else {
              this.frequency = individualMedicine[0].mor + "-" + individualMedicine[0].aft + "-" + individualMedicine[0].eve + "-" + individualMedicine[0].night;
              this.prescriptionForm.controls['timing'].setValue("4 Times");
              this.prescriptionForm.controls['frequency'].setValue(this.frequency);
            }
          }
          this.prescriptionForm.controls['qty'].setValue(individualMedicine[0].qty);
          this.prescriptionForm.controls['takenAt'].setValue(individualMedicine[0].takenAt);

          this.prescriptionForm.controls['mor'].setValue(individualMedicine[0].mor);
          this.prescriptionForm.controls['aft'].setValue(individualMedicine[0].aft);
          this.prescriptionForm.controls['night'].setValue(individualMedicine[0].night);
          this.prescriptionForm.controls['eve'].setValue(individualMedicine[0].eve);
        }
      }

    }

    this.prescriptionForm.controls['medicineName'].setValue(event?.[0]?.data.name);
    this.prescriptionForm.controls['presNameForQC'].setValue(event?.[0]?.data.name);
    this.prescriptionForm.controls['genericID'].setValue(event?.[0]?.data.genericId);
    this.prescriptionForm.controls['genericName'].setValue(typeof event?.[0]?.data.genericName === 'object' ? event?.[0]?.data.genericName.name : event?.[0]?.data.genericName);
    this.prescriptionForm.controls['categoryName'].setValue(event?.[0]?.data.medicineCategoryName != undefined ? event?.[0]?.data.medicineCategoryName : event?.[0]?.data.medicineCategory.name);


    if (event?.[0]?.data.medicineCategory) {
      if (event?.[0]?.data.medicineCategory.name.toLowerCase() == "syrup") {
        this.prescriptionForm.controls['categoryID'].setValue("Syrup");
        this.prescriptionForm.controls['dosageunit'].setValue("ml");

      }
      else if (event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "cream" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "gel"
        || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "lotion" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "mouth wash" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "gargles"
        || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "surgical" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "bandage" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "brush"
        || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "inhaler" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "mask" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "ointment"
        || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "powder" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "suspension" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "drops"
        || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "spray" || event?.[0]?.data?.medicineCategory?.name.toLowerCase() == "tooth paste") {
        this.prescriptionForm.controls['categoryID'].setValue("Others");
        this.prescriptionForm.controls['dosageunit'].setValue("nos");

      }
      else {
        this.prescriptionForm.controls['categoryID'].setValue("Non-Syrup");
        this.prescriptionForm.controls['dosageunit'].setValue("nos");
        this.prescriptionForm.controls['dosage'].setValue("1");

      }
    } else {

      if (event?.[0]?.data.medicineCategoryName.toLowerCase() == "syrup") {
        this.prescriptionForm.controls['categoryID'].setValue("Syrup");
        this.prescriptionForm.controls['dosageunit'].setValue("ml");

      }
      else if (event?.[0]?.data.medicineCategoryName.toLowerCase() == "cream" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "gel" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "lotion" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "mouth wash" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "gargles" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "surgical" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "bandage" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "brush" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "inhaler" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "mask" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "ointment" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "powder" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "spray" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "tooth paste" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "suspension" || event?.[0]?.data.medicineCategoryName.toLowerCase() == "drops") {
        this.prescriptionForm.controls['categoryID'].setValue("Others");
        this.prescriptionForm.controls['dosageunit'].setValue("nos");

      }
      else {
        this.prescriptionForm.controls['categoryID'].setValue("Non-Syrup");
        this.prescriptionForm.controls['dosageunit'].setValue("nos");
        this.prescriptionForm.controls['dosage'].setValue("1");

      }
    }



  }

  async selectmedicinedetails(data) {
    this.prescriptionForm.controls['medicineId'].setValue(data.id);
    this.prescriptionForm.controls['presNameForQC'].setValue(data.name);
    this.prescriptionForm.controls['medicineName'].setValue(data.name)
    this.prescriptionForm.controls['genericID'].setValue(data.genericId);
    this.prescriptionForm.controls['availablequantity'].setValue(data.currentStock);
  }

  levelChange(event) {

    var dosageunit;
    if (event?.[0]?.value == "nos") {
      dosageunit = "";
    }
    else {
      dosageunit = event?.[0]?.value;
    }
    var dossageData = this.prescriptionForm.get('dosage').value + dosageunit;

    this.calculateTimingLevels(dossageData);
  }

  calculateTimingLevels(dossageData) {

    if (!!dossageData && dossageData != "null" && dossageData != "nullml") {
      this.dosageLvl = dossageData;

      this.onceData = [];
      this.twiceData = [];
      this.thriceData = [];
      this.fouthData = [];

      // Timing once Data set:-
      this.onceData = [
        { name: dossageData + '-0-0', disabled: false, type: "Once" },
        { name: '0-' + dossageData + '-0', disabled: false, type: "Once" },
        { name: '0-0-' + dossageData, disabled: false, type: "Once" },
      ];

      // Timing twice Data set:-
      this.twiceData = [
        { name: dossageData + '-' + dossageData + '-0', disabled: false, type: "Twice" },
        { name: '0-' + dossageData + '-' + dossageData, disabled: false, type: "Twice" },
        { name: dossageData + '-0-' + dossageData, disabled: false, type: "Twice" },
      ];

      // Timing thrice Data set:-
      this.thriceData = [
        { name: dossageData + '-' + dossageData + '-' + dossageData, disabled: false, type: "Thrice" },
      ];

      // Timing fourth Data set:-
      this.fouthData = [
        { name: dossageData + '-' + dossageData + '-' + dossageData + '-' + dossageData, disabled: false, type: "4 Times" },
      ];
    } else {
      if (dossageData == "nullml") {
        this.dosageLvl = '1ml';
      }
      else {
        this.dosageLvl = '1';
      }

    }

  }

  getpriorityDetails() {
    this.glossarySrvc.list("tenants/" + this.tenandId + '/' + "MedicineGlossary/" + this.branchId + '/GetDataforPrescriptionPage').pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

      if (data?.message != "No records found") {

        this.routineData = data.filter(e => e.type.toLowerCase() === "Frequency".toLocaleLowerCase());
        this.whentotakenData = data.filter(e => e.type.toLowerCase() === "WhenToTaken".toLocaleLowerCase());
        this.dossageLevelData = data.filter(e => e.type.toLowerCase() === "Unit".toLocaleLowerCase());
        this.dossageData = data.filter(e => e.type.toLowerCase() === "DosageLevel".toLocaleLowerCase());
        this.frequencyData = data.filter(e => e.type.toLowerCase() === "Duration".toLocaleLowerCase());

      }

      if (this.routineData.length == 0) {
        this.routineData.push("Type to add");
      }
      if (this.whentotakenData.length == 0) {
        this.whentotakenData.push("Type to add");
      }
      if (this.dossageLevelData.length == 0) {
        this.dossageLevelData.push("Type to add");
      }
      if (this.dossageData.length == 0) {
        this.dossageData.push("Type to add");
      }
      if (this.frequencyData.length == 0) {
        this.frequencyData.push("Type to add");
      }
    }, (error) => {
    }, () => {
    });
  }

  selectTiming(i) {
    var originalData = [...this.sclDosage];
    this.sclDosage[i] = !this.sclDosage[i];
    if (originalData != this.sclDosage) {
      this.prescriptionForm.get('frequency').reset();
    }
    var time = [];
    var type = "";
    this.sclDosage.filter(x => {
      if (x)
        time.push('1');
      else
        time.push('0');
    });

    switch (this.sclDosage.filter(x => { if (x) { return x } }).length) {
      case 1: type = "Once"; break;
      case 2: type = "Twice"; break;
      case 3: type = "Thrice"; break;
      case 4: type = "4 Times"; break;
    }
    // this.showadvancedtiming=false;
    // this.prescriptionForm.controls['timing'].setValue(type);
    this.prescriptionForm.controls['mor'].setValue(time?.[0]);
    this.prescriptionForm.controls['aft'].setValue(time?.[1]);
    this.prescriptionForm.controls['eve'].setValue(time?.[2]);
    this.prescriptionForm.controls['night'].setValue(time?.[3]);



    this.prescriptionForm.controls['frequency'].setValue(time?.[0] + '-' + time?.[1] + '-' + time?.[2] + '-' + time?.[3]);

  }

  saveBloodGroup() {

  }

  getDuration(event) {
    this.onceAMonthErr = false;
    this.onceAWeekErr = false;
    this.alternateDayErr = false;
    var durationunit;
    var duration = event?.[0]?.value;
    var result = duration?.match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+|)/g);
    this.prescriptionForm.controls['duration'].setValue(duration);
    this.prescriptionForm.controls['durationcount'].setValue(result?.length > 1 ? result?.[0] : 0);

    if (result?.length == 2) {
      if (result?.[1] == 'd' || result?.[1] == 'D' || result?.[1].toLowerCase() == 'days') {
        durationunit = "Days";
      }
      else if (result?.[1] == 'm' || result?.[1] == 'M' || result?.[1].toLowerCase() == 'month' || result?.[1].toLowerCase() == 'months') {
        durationunit = "Month";
      }
      else if (result?.[1] == 'w' || result?.[1] == 'W' || result?.[1].toLowerCase() == 'week' || result?.[1].toLowerCase() == 'weeks') {
        durationunit = "Week";
      }

      this.prescriptionForm.controls['durationunit'].setValue(durationunit);

      if (result?.[1] == "d" || result?.[1] == 'D' || result?.[1].toLowerCase() == 'days') {
        this.prescriptionForm.controls['days'].setValue(result?.[0]);
      }
      else if (result?.[1] == "w" || result?.[1] == "W" || result?.[1].toLowerCase() == 'week' || result?.[1].toLowerCase() == 'weeks') {
        this.prescriptionForm.controls['days'].setValue(result?.[0] * 7);
      }
      else if (result?.[1] == "m" || result?.[1] == "M" || result?.[1].toLowerCase() == 'month' || result?.[1].toLowerCase() == 'months') {
        this.prescriptionForm.controls['days'].setValue(result?.[0] * 30);
      }

    }
    else if (result?.length == 3) {
      if (result?.[2] == 'd' || result?.[2] == 'D' || result?.[2].toLowerCase() == 'days') {
        durationunit = "Days";
      }
      else if (result?.[2] == 'm' || result?.[2] == 'M' || result?.[2].toLowerCase() == 'month' || result?.[2].toLowerCase() == 'months') {
        durationunit = "Month";
      }
      else if (result?.[2] == 'w' || result?.[2] == 'W' || result?.[2].toLowerCase() == 'week' || result?.[2].toLowerCase() == 'weeks') {
        durationunit = "Week";
      }

      this.prescriptionForm.controls['durationunit'].setValue(durationunit);

      if (result?.[2] == "d" || result?.[2] == "D" || result?.[2].toLowerCase() == 'days') {
        this.prescriptionForm.controls['days'].setValue(result?.[0]);
      }
      else if (result?.[2] == "w" || result?.[2] == "W" || result?.[2].toLowerCase() == 'week' || result?.[2].toLowerCase() == 'weeks') {
        this.prescriptionForm.controls['days'].setValue(result?.[0] * 7);
      }
      else if (result?.[2] == "m" || result?.[2] == "M" || result?.[2].toLowerCase() == 'month' || result?.[2].toLowerCase() == 'months') {
        this.prescriptionForm.controls['days'].setValue(result?.[0] * 30);
      }
    }
    else if (result?.length == 1) {
      durationunit = duration;
      this.prescriptionForm.controls['durationunit'].setValue(durationunit);
    }

    const numberPattern = /\d/;
    if (!numberPattern.test(duration)) {
      this.prescriptionForm.controls['durationunit'].setValue(duration);
      this.prescriptionForm.controls['days'].setValue(0);
      this.prescriptionForm.controls['durationcount'].setValue(0);
    }

    var mrng = this.prescriptionForm.get('mor').value?.match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+|)/g);
    var noon = this.prescriptionForm.get('aft').value?.match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+|)/g);
    var eveng = this.prescriptionForm.get('eve').value?.match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+|)/g);
    var night = this.prescriptionForm.get('night').value?.match(/[a-zA-Z]+|[0-9]+(?:\.[0-9]+|)/g);

    this.mrng = parseFloat(mrng) >= 1 ? parseFloat(mrng) : parseFloat(mrng) == 0 ? 0 : parseFloat(mrng);
    this.noon = parseFloat(noon) >= 1 ? parseFloat(noon) : parseFloat(noon) == 0 ? 0 : parseFloat(noon);
    this.eveng = parseFloat(eveng) >= 1 ? parseFloat(eveng) : parseFloat(eveng) == 0 ? 0 : parseFloat(eveng);
    this.night = parseFloat(night) >= 1 ? parseFloat(night) : parseFloat(night) == 0 ? 0 : parseFloat(night);

    var count = 0;
    count = this.mrng + this.noon + this.eveng + this.night;

    var freaquency = this.prescriptionForm.get('frequency').value;
    if (freaquency == "Once a Month" || freaquency == "Every Week" || freaquency == "Every Alternate Day") {
      if (freaquency == "Once a Month") {
        var totalDays = this.prescriptionForm.get('days').value;
        if (totalDays >= 30) {
          this.prescriptionForm.controls['qty'].setValue(Math.ceil(totalDays / 30));
        }
        else {
          this.onceAMonthErr = true;
          this.prescriptionForm.controls['qty'].setValue(null);
        }
      }
      else if (freaquency == "Every Week") {
        var totalDays = this.prescriptionForm.get('days').value;
        if (totalDays >= 7) {
          this.prescriptionForm.controls['qty'].setValue(Math.ceil(totalDays / 7));
        }
        else {
          this.onceAWeekErr = true;
          this.prescriptionForm.controls['qty'].setValue(null);
        }
      }
      else if (freaquency == "Every Alternate Day") {
        var totalDays = this.prescriptionForm.get('days').value;
        if (totalDays >= 2) {
          this.prescriptionForm.controls['qty'].setValue(Math.ceil(totalDays / 2));
        }
        else {
          this.alternateDayErr = true;
          this.prescriptionForm.controls['qty'].setValue(null);
        }
      }
    }
    else {
      if (this.prescriptionForm.get('categoryID')?.value?.toLowerCase() != "syrup" && this.prescriptionForm.get('categoryID')?.value?.toLowerCase() != "others") {
        const det = !!(this.prescriptionForm.get('days').value * count) ? this.prescriptionForm.get('days').value * count : 0;
        this.prescriptionForm.controls['qty']?.setValue(Math.ceil(det));
      }
      else {
        this.prescriptionForm.controls['qty'].setValue(1);
      }
    }

    if ((this.prescriptionForm?.get('categoryName')?.value?.toLowerCase() == "tablets"
      || this.prescriptionForm?.get('categoryName')?.value?.toLowerCase() == "capsule"
      || this.prescriptionForm?.get('categoryName')?.value?.toLowerCase() == "capsules"
      || this.prescriptionForm?.get('categoryName')?.value?.toLowerCase() == "injection") &&
      (freaquency == "Every 2 hours" || freaquency == "Every 3 hours" || freaquency == "Every 4 hours" || freaquency == "Every 6 hours")) {
      if (freaquency == "Every 2 hours") {
        var qty = this.prescriptionForm.get('days').value * 12
        this.prescriptionForm.controls['qty'].setValue(qty);
      }
      if (freaquency == "Every 3 hours") {
        var qty = this.prescriptionForm.get('days').value * 8
        this.prescriptionForm.controls['qty'].setValue(qty);
      }
      if (freaquency == "Every 4 hours") {
        var qty = this.prescriptionForm.get('days').value * 6
        this.prescriptionForm.controls['qty'].setValue(qty);
      }
      if (freaquency == "Every 6 hours") {
        var qty = this.prescriptionForm.get('days').value * 4
        this.prescriptionForm.controls['qty'].setValue(qty);
      }


    }

  }

  checkFormat(value) {
    if (!!value) {
      var val = value?.toString()?.toLowerCase()[value?.toString()?.length - 1]
      if (!this.incorrectformatduration) {
        if (!(val == "d" || val == "w" || val == "m") && parseInt(value[0]) >= 0)
          this.incorrectformatduration = true
      }
      else {
        this.incorrectformatduration = false;
        this.prescriptionForm.controls['duration'].setValue(null);
      }
    }
  }

  AddFavorite() {
    this.isfavorite = true;
    this.nameflag = false;
  }

  onCancel() {
    this.isfavorite = false;
    this.newFavoriteForm.reset();
  }

  dupcheckValue(value) {
    if (!!this.favoritesList.find(x => { return x.name.toLowerCase() == value?.toLowerCase() }))
      this.nameflag = true;
    else
      this.nameflag = false;
  }

  onSubmit() {
    if (this.nameflag == false && this.newFavoriteForm.valid) {

      this.mname = this.newFavoriteForm.get('name').value;
      var senddata = this.currentVisitPrescriptions.map(x => {
        return {
          physicianId: this.docId,
          name: this.mname,
          medicineId: x.medicineId,
          days: x.days,
          mor: x.mor,
          aft: x.aft,
          eve: x.eve,
          night: x.night,
          qty: x.qty,
          takenAt: x.takenAt,
          instructions: x.instructions,
          frequency: x.frequency,
          dosage: x.dosage,
          dosageunit: x.dosageunit,
          advice: x.advice,
          duration: x.durationcount || x.duration,
          durationUnit: x.durationunit || x.durationUnit,
          tenantId: this.tenandId,
          branchId: this.branchId,
          createdDate: new Date(),
          updatedDate: null,
          createdBy: parseInt(this.userId),
          updatedBy: null,
          createdIP: null,
          updatedIP: null

        }
      });
      if (senddata.length > 0) {
        this.favoriteMedicineSrvc.create("favoritemedicine/" + this.tenandId + '/' + this.branchId + '/SaveMultipleFavpre', senddata).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.newFavoriteForm.controls['name'].setValue(null);
          this.setValues({ value: data });
          this.isfavorite = false;
        }, (error) => {
          this.isfavorite = false;
        }, () => {
          this.toaster.ForSuccess('Saved Successfully');
          this.loadFavoritePrescriptionData();
          this.newFavoriteForm.reset()
          this.isfavorite = false;
        });
      }

    }

  }

  resetAll() {
    this.resetPres();
    this.resetComp();
    this.resetDiag();
    this.resetInves();
    this.resetFollow();
    this.resetAllergy();
    this.resetCurrMed();
    this.resetSocialHabits();
    this.resetMedHis();
    this.resetFamilyHist();
    this.addedPrescription = this.addedPrescription?.filter(x => x.visitId != this.visitId);
    this.addedComplaints = this.addedComplaints?.filter(x => x.visitId != this.visitId);
    this.patientAddedComplaints = this.addedComplaints?.filter(c => c.visitId == 0)?.sort((a, b) => new Date(b?.createdDate).getTime() - new Date(a?.createdDate).getTime());
    this.addedDiagnosis = this.addedDiagnosis?.filter(x => x.visitId != this.visitId);
    this.addedInves = this.addedInves?.filter(x => x.visitId != this.visitId);
    this.addedfollowUp = this.addedfollowUp?.filter(x => x.visitId != this.visitId);
    this.addedSocialHabits = this.addedSocialHabits?.filter(x => x.visitId != this.visitId);
    this.addedCurrentMedications = this.addedCurrentMedications?.filter(x => x.visitId != this.visitId);
    this.addedAllergies = this.addedAllergies?.filter(x => x.visitId != this.visitId);
    this.addedMedicalHistories = this.addedMedicalHistories?.filter(x => x.visitId != this.visitId);
    this.addedFamilyHistories = this.addedFamilyHistories?.filter(x => x.visitId != this.visitId);
    if (!!this.tempVitalsData) {
      this.vitalsData = this.tempVitalsData;
      this.editVitals = true;
      this.vitalForms.patchValue(this.tempVitalsData);
    }
    else {
      this.editVitals = false;
      this.vitalsData ={};
      this.resetVitals();
    }
  }

  closeEHR() {
    this.closeEvent.emit();
  }

  showPastRecord() {
    this.fetchHistoryDetails();
  }


  fetchHistoryDetails() {

    this.rolesService.list(`patientcomplaint/${this.tenandId}/${this.branchId}/${this.regId}/0/comlaintsdashboard`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      data = data?.map(e => {
        const parsedVaccines = e?.vaccine?.map(v => ({
          visitId: v?.visitId,
          input: v?.inputJson ? JSON.parse(v.inputJson) : '-'
        })) || [];

        return {
          ...e,
          parsedVaccines
        };
      });
      for (var i = 0; i < data.length; i++) {
        // merge objects into one with multiple props
        data[i] = Object.assign(data[i], {
          index: i + 1
        });
      }
      this.visitHistoryData = data;
      this.searchDet();
    }, (error) => {
      this.searchDet();
    }, () => { });
  }


  prevclicked() {
    if (this.p > 1) {
      this.p = this.p - 1;
    }
  }

  nextclicked() {
    if (this.p < Math.ceil(this.visitHistoryData?.length / 5)) {
      this.p += 1;
    }
  }

  infoCancel(): void {
    this.isImgView = false;
  }

  view(x): void {
    // this.assetData.assetRegMstCreate<any,any>(`AtchDet/${this.tenantId}/${this.branchId}/download`,x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.rolesService.create(`${environment.apiUrl}/AtchDet/${this.tenandId}/${this.branchId}/download`, x).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      //this.srcData = data;
      if ((x.fileName as string).indexOf(".jpg") > -1 || (x.fileName as string).indexOf(".png") > -1) {
        this.isImgView = true;
        this.pdfUrl = null;
        this.srcname = 'data:image/jpeg;base64,' + data;
        // this.fileToLoad = data.fileName;   
      } else if (x.fileName.indexOf(".pdf") > -1) {

        var binary_string = window.atob(data);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
        }
        var byteArray = bytes.buffer;
        var blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        this.isImgView = false;
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        //  window.open(url);
      }
      else {
        this.pdfUrl = null;
        this.isImgView = false;
        this.downloadFileRes(data, x.fileName);
      }

    }, (error) => {

    }, () => {

    });

  }

  loadPatientMedicalHistories() {
    this.rolesService.list(`ehrOptimizationController/${this.tenandId}/${this.branchId}/${this.regId}/GetPatentHistoryFOrHealthRecord/general`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      data.patientprescription = data?.patientprescription?.length > 0
        ? data?.patientprescription?.sort((a, b) => {
          const Comparison = b?.visitId - a?.visitId;
          if (Comparison !== 0) {
            return Comparison;
          }
          return a.sortOrderId - b.sortOrderId;
        })
        : [];
      this.pastPrescriptionHistories = data.patientprescription;
      this.isPastRecord = true;
    }, (error) => {
      this.isPastRecord = true;
    }, () => {
    });

  }

  downloadFileRes(data: any, filename: string) {

    var binary_string = window.atob(data);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    var byteArray = bytes.buffer;

    if (filename.indexOf(".pdf") > -1) {
      var blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    }
    else {
      var blob = new Blob([byteArray]);
      FileSaver.saveAs(blob, filename, true);
    }

  }

  searchDet() {
    if (this.tenandId != null && this.branchId != null) {

      this.rolesService.getById(`${environment.apiUrl}/AtchDet/${this.tenandId}/${this.branchId}/getRadDet/${this.curDetPat?.mobile}/${this.curDetPat?.patFiName}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        if (data == null || data?.length == 0) {
          this.medicalRecords = [];
        }
        this.medicalRecords = data;
        this.loadPatientMedicalHistories();


      }, (error) => {
        this.medicalRecords = [];
        this.loadPatientMedicalHistories();

      }, () => { });
    }

  }

  onBpSysChange(value) {
    if (!!value) {
      this.vitalForms?.get('bP_Dia')?.setValidators([Validators.required,Validators.min(0),Validators.max(500),Validators.pattern('^[0-9.]+$')]);
    }
    else {
      this.vitalForms?.get('bP_Dia')?.setValidators([Validators.min(0),Validators.max(500),Validators.pattern('^[0-9.]+$')]);
    }
    this.vitalForms?.get('bP_Dia')?.updateValueAndValidity();
  }

  onBpDiaChange(value) {
    if (!!value) {
      this.vitalForms?.get('bP_Sys')?.setValidators([Validators.required,Validators.min(0),Validators.max(500),Validators.pattern('^[0-9.]+$')]);
    }
    else {
      this.vitalForms?.get('bP_Sys')?.setValidators([Validators.min(0),Validators.max(500),Validators.pattern('^[0-9.]+$')]);
    }
    this.vitalForms?.get('bP_Sys')?.updateValueAndValidity();
  }

  onTemperatureChange(event: KeyboardEvent, el: any) {

    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = el.value;
    const position = el.value.length;
    const next: string = [current?.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current?.slice(position)].join('');
    if (next && !String(next)?.match(this.regex)) {
      event.preventDefault();
    }
  }

  loadAllergiesMaster() {
    if(this.allergyAllList.length>0) return;
    this.rolesService.list('/tenants/' + this.tenandId + '/' + this.branchId + "/allergy")
      .pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.allergyAllList = data;
      })
  }

  durationchange() {
    this.patientAllergyEditForm.controls["duration"].valueChanges.subscribe((values: number) => {
      if (values == 1) {
        this.patientAllergyEditForm.controls["period"].setValue(this.periodList[0].value);
        this.periodList = [
          { value: "day" },
          { value: "week" },
          { value: "month" },
          { value: "year" },
        ]
      }
      else if (values != 1) {
        this.patientAllergyEditForm.controls["period"].setValue(this.periodList[0].value);
        this.periodList = [
          { value: "days" },
          { value: "weeks" },
          { value: "months" },
          { value: "years" },
        ]
      }
    });
    this.dflag = true;
  }

  onChangeEvent(event: any) {
    if (event != null && event != "") {
      const value = this.patientmedicalHistoryForm.get('duration').value;
      if (this.patientmedicalHistoryForm.get('period').value != null && this.patientmedicalHistoryForm.get('period').value != undefined) {
        if (this.patientmedicalHistoryForm.get('period').value == "day(s)") {
          let EDDValue: Date = this.dateService.addDay(new Date(), - value);
          // this.EDDDate = EDDValue;
          this.patientmedicalHistoryForm.controls['startDate'].setValue(EDDValue);
        }
        if (this.patientmedicalHistoryForm.get('period').value == "week(s)") {
          let weekValue = value * 7;
          let EDDValue: Date = this.dateService.addDay(new Date(), - weekValue);
          // this.EDDDate = EDDValue;
          this.patientmedicalHistoryForm.controls['startDate'].setValue(EDDValue);
        }
        if (this.patientmedicalHistoryForm.get('period').value == "year(s)") {

          let EDDValue: Date = this.dateService.addYear(new Date(), - value);
          // this.EDDDate = EDDValue;
          this.patientmedicalHistoryForm.controls['startDate'].setValue(EDDValue);
        }
        if (this.patientmedicalHistoryForm.get('period').value == "month(s)") {
          let EDDValue: Date = this.dateService.addMonth(new Date(), - value);
          // this.EDDDate = EDDValue;
          this.patientmedicalHistoryForm.controls['startDate'].setValue(EDDValue);
        }
      }
    }
  }

  durationchangeFamHis() {
    this.FamilyHisForm.controls["duration"].valueChanges.subscribe((values: number) => {
      if (values == 1) {
        this.FamilyHisForm.controls["period"].setValue(this.periodList[0].value);
        this.periodList = [
          { value: "day" },
          { value: "week" },
          { value: "month" },
          { value: "year" },
        ]
      }
      else if (values != 1) {
        this.FamilyHisForm.controls["period"].setValue(this.periodList[0].value);
        this.periodList = [
          { value: "days" },
          { value: "weeks" },
          { value: "months" },
          { value: "years" },
        ]
      }
    });



    this.dflag = true;
  }

  durationchangeSocial() {
    this.patientSocialHabitsEditForm.controls["duration"].valueChanges.subscribe((values: number) => {
      if (values == 1) {
        this.patientSocialHabitsEditForm.controls["period"].setValue(this.periodList[0].value);
        this.periodList = [
          { value: "day" },
          { value: "week" },
          { value: "month" },
          { value: "year" },
        ]
      }
      else if (values != 1) {
        this.patientSocialHabitsEditForm.controls["period"].setValue(this.periodList[0].value);
        this.periodList = [
          { value: "days" },
          { value: "weeks" },
          { value: "months" },
          { value: "years" },
        ]
      }
    });


    this.dflag = true;
  }

  onDateChoose() {
    var startDate = this.patientmedicalHistoryForm.get('startDate').value;
    var endDate = this.patientmedicalHistoryForm.get('endDate').value;
    if (startDate != undefined && endDate != undefined && startDate != null
      && endDate != null) {

      startDate = formatDate(startDate, 'yyyy-MM-dd', 'en-US');
      endDate = formatDate(endDate, 'yyyy-MM-dd', 'en-US');

      if (startDate <= endDate) {
        this.DateExceeds = false;
      }
      else {
        this.DateExceeds = true;


      }
    }

  }

  takenchnage(event) {
    
    var dossage;
    if (event?.[0]?.value.trim() == "1 - 0 - 1") {
      this.sclDosage[0] = true;
      this.sclDosage[1] = false;
      this.sclDosage[2] = false;
      this.sclDosage[3] = true;
    }
    else if (event?.[0]?.value.trim() == "1 - 1 - 1") {
      this.sclDosage[0] = true;
      this.sclDosage[1] = true;
      this.sclDosage[2] = false;
      this.sclDosage[3] = true;
    }
    else if (event?.[0]?.value == "1 - 0 - 0") {
      this.sclDosage[0] = true;
      this.sclDosage[1] = false;
      this.sclDosage[2] = false;
      this.sclDosage[3] = false;
    }
    else if (event?.[0]?.value == "0 - 0 - 1") {
      this.sclDosage[0] = false;
      this.sclDosage[1] = false;
      this.sclDosage[2] = false;
      this.sclDosage[3] = true;
    }
    else if (event?.[0]?.value == "0 - 1 - 0") {
      this.sclDosage[0] = false;
      this.sclDosage[1] = true;
      this.sclDosage[2] = false;
      this.sclDosage[3] = false;
    }
    else if (event?.[0]?.value.trim() == "1 - 1 - 1 - 1") {
      this.sclDosage[0] = true;
      this.sclDosage[1] = true;
      this.sclDosage[2] = true;
      this.sclDosage[3] = true;
    }
    else {
      this.sclDosage[0] = false;
      this.sclDosage[1] = false;
      this.sclDosage[2] = false;
      this.sclDosage[3] = false;
    }

    var result = event?.[0]?.value.split(" - ", 15);

    this.prescriptionForm.controls['mor'].setValue(result?.[0] == '0' ? '0' : dossage);
    this.prescriptionForm.controls['aft'].setValue(result?.[1] == '0' ? '0' : dossage);
    this.prescriptionForm.controls['night'].setValue(result?.[2] == '0' ? '0' : dossage);
    if (result?.length == 4) {
      this.prescriptionForm.controls['eve'].setValue(result?.[3] == '0' ? '0' : dossage);
    }
    else {
      this.prescriptionForm.controls['eve'].setValue('0');
    }
    if ((event?.[0]?.value == 'STAT' || event?.[0]?.value == 'SOS' || event?.[0]?.value == 'Once a Month' || event?.[0]?.value == 'Every Week' || event?.[0]?.value == 'Every Alternate Day') || this.isnewFrequency(event?.[0]?.value)) {

      this.sclDosage[0] = false;
      this.sclDosage[1] = false;
      this.sclDosage[2] = false;
      this.sclDosage[3] = false;

      this.prescriptionForm.controls['mor'].setValue(null);
      this.prescriptionForm.controls['aft'].setValue(null);
      this.prescriptionForm.controls['night'].setValue(null);
      this.prescriptionForm.controls['eve'].setValue(null);

    }

  }

  isnewFrequency(value) {
    return (
      value?.trim() != "1 - 0 - 1" &&
      value?.trim() != "1 - 1 - 1" &&
      value?.trim() != "1 - 0 - 0" &&
      value?.trim() != "0 - 0 - 1" &&
      value?.trim() != "0 - 1 - 0" &&
      value?.trim() != "1 - 1 - 1 - 1"
    );
  }

  // selectTimingForCurrMed(i) {
  //   var originalData = [...this.sclDosageCurrMed];
  //   this.sclDosageCurrMed[i] = !this.sclDosageCurrMed[i];
  //   if (originalData != this.sclDosageCurrMed) {
  //     this.patientmedicationEditForm.get('timingLevel').reset();
  //   }
  //   var time = [];
  //   var type = "";
  //   this.sclDosageCurrMed.filter(x => {
  //     if (x)
  //       time.push('1');
  //     else
  //       time.push('0');
  //   });

  //   switch (this.sclDosageCurrMed.filter(x => { if (x) { return x } }).length) {
  //     case 1: type = "Once"; break;
  //     case 2: type = "Twice"; break;
  //     case 3: type = "Thrice"; break;
  //     case 4: type = "4 Times"; break;
  //   }
  //   // this.showadvancedtiming=false;
  //   // this.patientmedicationEditForm.controls['timing'].setValue(type);
  //   this.patientmedicationEditForm.controls['mrng'].setValue(time?.[0]);
  //   this.patientmedicationEditForm.controls['noon'].setValue(time?.[1]);
  //   this.patientmedicationEditForm.controls['evening'].setValue(time?.[2]);
  //   this.patientmedicationEditForm.controls['night'].setValue(time?.[3]);



  //   this.patientmedicationEditForm.controls['timingLevel'].setValue(time?.[0] + '-' + time?.[1] + '-' + time?.[2] + '-' + time?.[3]);

  // }

  getSelectedLanguageName(): string {
    const lang = this.supportedLanguages.find(l => l.code === this.selectedLanguage);
    return lang ? lang.name : 'English (India)';
  }

  // Urdu / Arabic are written right-to-left; matched on the language code prefix (ur-*, ar-*), not the label.
  get isRtlLanguage(): boolean {
    return ['ur', 'ar'].includes((this.selectedLanguage || '').toLowerCase().split(/[-_]/)[0]);
  }

  // The English translation view always stays LTR; only the original speech follows the selected language.
  get speechTextDir(): 'rtl' | 'ltr' {
    return this.isRtlLanguage && !this.isShowingTranslation ? 'rtl' : 'ltr';
  }

  // MULTILANG-START
  get isTranslationSupported(): boolean {
    return this.selectedLanguage !== 'en-IN' && this.selectedLanguage !== 'en-US';
  }

  get isShowingTranslation(): boolean {
    return this.activeTranscriptView === 'translation' && this.isTranslationSupported && (!!this.accumulatedTranslation || !!this.interimTranslation);
  }

  onTranscriptViewChange(view: 'original' | 'translation') {
    this.activeTranscriptView = view;
    this.updateSpeechCounts();
    this.requestSpeechEditorSync({ force: true, preserveCursor: false });
    this.cdr.detectChanges();
  }
  // MULTILANG-END

  onSpeechManualInput(event: Event) {
    const target = event.target as HTMLElement;
    if (this.isShowingTranslation) {
      this.accumulatedTranslation = target?.innerText || '';
    } else {
      this.accumulatedSpeechText = target?.innerText || '';
    }
    this.updateSpeechCounts();
    this.scheduleManualSync();
  }

  onSpeechFocus() {
    this.speechEditorFocused = true;
  }

  onSpeechBlur() {
    this.speechEditorFocused = false;
    if (this.isShowingTranslation) {
      if (this.accumulatedTranslation) {
        this.accumulatedTranslation = this.accumulatedTranslation.replace(/\u00A0/g, ' ');
        this.updateSpeechCounts();
      }
    } else {
      if (this.accumulatedSpeechText) {
        this.accumulatedSpeechText = this.accumulatedSpeechText.replace(/\u00A0/g, ' ');
        this.updateSpeechCounts();
      }
    }
    this.pushManualSync();
    this.requestSpeechEditorSync({ force: true, preserveCursor: false });
  }

  private requestSpeechEditorSync(options: { force?: boolean; preserveCursor?: boolean } = {}) {
    this.pendingSpeechEditorSyncOptions = options;
    if (this.speechEditorSyncHandle) {
      return;
    }
    this.speechEditorSyncHandle = setTimeout(() => {
      this.speechEditorSyncHandle = null;
      const appliedOptions = this.pendingSpeechEditorSyncOptions || {};
      this.pendingSpeechEditorSyncOptions = null;
      this.applySpeechEditorSync(appliedOptions);
    });
  }

  private applySpeechEditorSync(options: { force?: boolean; preserveCursor?: boolean } = {}) {
    const editor = this.speechTextEditorRef?.nativeElement;
    if (!editor) {
      return;
    }
    const desiredText = this.isShowingTranslation ? (this.accumulatedTranslation || '') : (this.accumulatedSpeechText || '');
    if (!options.force && editor.innerText === desiredText) {
      return;
    }

    const shouldPreserveCursor = options.preserveCursor !== false;
    const caretOffset = shouldPreserveCursor ? this.captureCaretOffset(editor) : null;

    editor.textContent = desiredText;

    if (caretOffset !== null) {
      this.restoreCaretOffset(editor, caretOffset);
    }
  }

  private captureCaretOffset(container: HTMLElement): number | null {
    if (typeof window === 'undefined') {
      return null;
    }
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
      return null;
    }
    const range = selection.getRangeAt(0);
    if (!container.contains(range.startContainer)) {
      return null;
    }
    const preRange = range.cloneRange();
    preRange.selectNodeContents(container);
    preRange.setEnd(range.startContainer, range.startOffset);
    return preRange.toString().length;
  }

  private restoreCaretOffset(container: HTMLElement, offset: number) {
    if (typeof window === 'undefined') {
      return;
    }
    const docRef = (typeof document !== 'undefined' ? document : null);
    if (!docRef) {
      return;
    }
    const selection = window.getSelection();
    if (!selection) {
      return;
    }
    const textNode = container.firstChild as Text;
    if (!textNode) {
      container.focus();
      return;
    }
    const maxOffset = (textNode.textContent || '').length;
    const clampedOffset = Math.min(offset, maxOffset);
    const range = docRef.createRange();
    range.setStart(textNode, clampedOffset);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
  }
  // convoAI start here
  loadLanguages() {
    this.audioSpeechService.fetchSupportedLanguages().then(data => {
      if (data && data.languages && data.languages.length > 0) {
        this.supportedLanguages = data.languages;
      } else {
        this.supportedLanguages = [
          { name: 'English (India)', code: 'en-IN' },
          { name: 'Tamil', code: 'ta-IN' },
          { name: 'Hindi', code: 'hi-IN' }
        ];
      }
      this.cdr.detectChanges();
    }).catch(error => {
      this.supportedLanguages = [
        { name: 'English (India)', code: 'en-IN' },
        { name: 'Tamil', code: 'ta-IN' },
        { name: 'Hindi', code: 'hi-IN' }
      ];
      this.cdr.detectChanges();
    });
  }

  private correctText(text: string): string {
    if (!text) {
      return text;
    }
    return text.replace(/\bJake\b/gi, 'Jai');
  }

  async toggleSpeechMic() {
    if (this.isSpeechRecording) {
      if (this.speechSilenceTimer) {
        clearTimeout(this.speechSilenceTimer);
      }
      this.mergeInterimSpeechIntoFinal();
      this.pushTranscriptToBackend('stop');
      this.audioSpeechService.stopStreaming();
    } else {
      await this.audioSpeechService.socketWeb();
      this.lastSpeechSeq = -1;
      this.interimSpeechText = '';
      this.interimTranslation = '';
      this.accumulatedTranslation = '';
      this.isAIComplete = false;
      this.aiCompleteMessage = '';
      this.isAISuggestionsPopulating = false;
      this.updateSpeechCounts();
      this.requestSpeechEditorSync({ force: true, preserveCursor: false });

      this.audioSpeechService.startStreaming(this.selectedLanguage).then(() => {
        this.resetSpeechSilenceTimer();
        this.cdr.detectChanges();
      }).catch(() => {
        this.toaster.ForDanger('Failed to start microphone. Please check permissions.');
        this.stopConversationAILoader();
        this.isAISuggestionsPopulating = false;
        this.cdr.detectChanges();
      });
    }
    this.cdr.detectChanges();
  }

  private mergeInterimSpeechIntoFinal() {
    if (this.interimSpeechText?.trim()) {
      const existing = (this.accumulatedSpeechText || '').trim();
      const interim = this.interimSpeechText.trim();
      this.accumulatedSpeechText = existing ? `${existing}  ${interim}` : interim;
      this.interimSpeechText = '';
    }
    if (this.interimTranslation?.trim()) {
      const existingTrans = (this.accumulatedTranslation || '').trim();
      const interimTrans = this.interimTranslation.trim();
      this.accumulatedTranslation = existingTrans ? `${existingTrans}  ${interimTrans}` : interimTrans;
      this.interimTranslation = '';
    }
    this.updateSpeechCounts();
  }

  private buildTranscriptPayload(source: 'stop' | 'manual'): FinalTranscriptPayload | null {
    const text = (this.accumulatedSpeechText || '').trim();
    const translation = (this.accumulatedTranslation || '').trim();
    if (!text && !translation) {
      return null;
    }

    return {
      text,
      translation,
      appointmentId: this.curDetPat?.appointmentNumber || '',
      visitId: this.visitId,
      doctorId: this.docId,
      patientRegId: this.regId,
      roomId: `${this.curDetPat?.appointmentNumber || ''}-${this.docId}`,
      timestamp: new Date().toISOString(),
      meta: {
        source,
        tenantId: this.curDetPat?.tenantId || '',
        branchId: this.curDetPat?.branchId || '',
      },
    };
  }

  private pushTranscriptToBackend(source: 'stop' | 'manual') {
    const payload = this.buildTranscriptPayload(source);
    if (!payload) {
      if (source === 'stop') {
        this.stopConversationAILoader();
        this.isAISuggestionsPopulating = false;
      }
      return;
    }
    this.audioSpeechService.submitTranscript(payload);
    this.lastSyncedManualText = payload.text;
    this.lastSyncedManualTranslation = payload.translation || '';
    this.cancelManualSyncTimer();
    if (source === 'stop') {
      this.startConversationAIProcessingCycle();
    }
  }

  private handleTranscriptionUpdate(update: any) {
    this.resetSpeechSilenceTimer();

    if (update.seq !== undefined && update.seq <= this.lastSpeechSeq) {
      return;
    }
    if (update.seq !== undefined) {
      this.lastSpeechSeq = update.seq;
    }

    if (update.status === 'error') {
      this.stopConversationAILoader();
      this.isAISuggestionsPopulating = false;
      return;
    }

    if (update.status === 'stopped') {
      this.isSpeechRecording = false;
      if (this.speechSilenceTimer) clearTimeout(this.speechSilenceTimer);
      this.mergeInterimSpeechIntoFinal();
      this.pushTranscriptToBackend('stop');
      this.audioSpeechService.stopStreaming();
      this.cdr.detectChanges();
      return;
    }

    if (update.type === 'interim') {
      this.interimSpeechText = this.correctText(update.interim_text);
      this.interimTranslation = update.interim_translation ? this.correctText(update.interim_translation) : '';
    } else if (update.type === 'final') {
      const correctedSegment = this.correctText(update.new_segment);
      if (this.accumulatedSpeechText) {
        this.accumulatedSpeechText = this.accumulatedSpeechText.trim() + ' ' + correctedSegment;
      } else {
        this.accumulatedSpeechText = correctedSegment;
      }
      this.interimSpeechText = '';

      if (update.new_translation) {
        const correctedTranslation = this.correctText(update.new_translation);
        if (this.accumulatedTranslation) {
          this.accumulatedTranslation = this.accumulatedTranslation.trim() + ' ' + correctedTranslation;
        } else {
          this.accumulatedTranslation = correctedTranslation;
        }
      }
      this.interimTranslation = '';

      this.updateSpeechCounts();
      this.lastSyncedManualText = (this.accumulatedSpeechText || '').trim();
      this.lastSyncedManualTranslation = (this.accumulatedTranslation || '').trim();
      this.cancelManualSyncTimer();
      this.requestSpeechEditorSync();
    } else if (update.type === 'manual') {
      const correctedFull = this.correctText(update.accumulated_text || '');
      this.accumulatedSpeechText = correctedFull;
      this.interimSpeechText = '';

      if (update.accumulated_translation !== undefined) {
        this.accumulatedTranslation = this.correctText(update.accumulated_translation);
      }
      this.interimTranslation = '';

      this.updateSpeechCounts();
      this.lastSyncedManualText = (this.accumulatedSpeechText || '').trim();
      this.lastSyncedManualTranslation = (this.accumulatedTranslation || '').trim();
      this.cancelManualSyncTimer();
      this.requestSpeechEditorSync({ force: true });
    }
    this.cdr.detectChanges();
  }

  private resetSpeechSilenceTimer() {
    if (this.speechSilenceTimer) {
      clearTimeout(this.speechSilenceTimer);
    }

    // Auto-stop after 20 seconds of silence from the frontend side
    this.speechSilenceTimer = setTimeout(() => {
      this.isSpeechRecording = false;
      this.mergeInterimSpeechIntoFinal();
      this.pushTranscriptToBackend('stop');
      this.audioSpeechService.stopStreaming();
      this.cdr.detectChanges();
    }, 20000);
  }

  private updateSpeechCounts() {
    const textToCount = this.isShowingTranslation ? (this.accumulatedTranslation || '') : (this.accumulatedSpeechText || '');
    this.wordCount = textToCount ? textToCount.split(/\s+/).filter(w => w.length > 0).length : 0;
    this.charCount = textToCount.length;
  }

  clearSpeechText() {
    if (this.isSpeechRecording) {
      this.toaster.ForDanger('Please stop recording before clearing text.');
      return;
    }
    this.audioSpeechService.clearText();
    this.accumulatedSpeechText = '';
    this.interimSpeechText = '';
    this.accumulatedTranslation = '';
    this.interimTranslation = '';
    this.isAIComplete = false;
    this.aiCompleteMessage = '';
    this.isAISuggestionsPopulating = false;
    this.updateSpeechCounts();
    this.lastSyncedManualText = '';
    this.lastSyncedManualTranslation = '';
    this.cancelManualSyncTimer();
    this.requestSpeechEditorSync({ force: true, preserveCursor: false });
  }

  private scheduleManualSync() {
    if (this.manualUpdateTimer) {
      clearTimeout(this.manualUpdateTimer);
    }
    this.manualUpdateTimer = setTimeout(() => {
      this.manualUpdateTimer = null;
      this.pushManualSync();
    }, this.manualSyncDelay);
  }

  private pushManualSync() {
    const payload = this.buildTranscriptPayload('manual');
    if (!payload) {
      return;
    }
    if (payload.text === this.lastSyncedManualText && payload.translation === this.lastSyncedManualTranslation) {
      return;
    }
    this.audioSpeechService.pushManualTranscript(payload);
    this.lastSyncedManualText = payload.text;
    this.lastSyncedManualTranslation = payload.translation || '';
  }

  private cancelManualSyncTimer() {
    if (this.manualUpdateTimer) {
      clearTimeout(this.manualUpdateTimer);
      this.manualUpdateTimer = null;
    }
  }
  // convoAI end here

  convertCamelCaseToTitle(text: string): string {
  if (!text) return '';

  return text
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, str => str.toUpperCase());
}
}
